import {
  BellAlertIcon,
  ChevronDoubleDownIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  HomeModernIcon,
  InformationCircleIcon,
  QuestionMarkCircleIcon,
  TrashIcon,
  XCircleIcon,
} from '@heroicons/react/24/solid';
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Chip,
  IconButton,
  Input,
  Option,
  Select,
  Textarea,
  Tooltip,
} from '@material-tailwind/react';
import { useState, useEffect, useRef } from 'react';
import MapComponent from '../../../components/MapComponent';
import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import { convertNumberToWords, encode, getCookie, numberFormatTextShorten } from '../../../utils/helper';
import * as imgDF from '../../../assets/images/index';
import {
  listAllDactrung,
  listAllHuongBds,
  listAllKqhs,
  listAllLoaibds,
  listAllPhaply,
  listAllQhs,
  listAllStreets,
  listAllStreetsGroup,
  listAllTiennghi,
  listAllVitri,
} from '../../../services/apiCategory';
import { API_URL } from '../../../utils/urls';
import {
  addBds,
  addCmt,
  checkPhoneChu,
  checkPhoneChuOld,
  getHistoryBDS,
  getIdBds,
  historyBds,
  listProductIDShow,
  updateBds,
} from '../../../services/apiBds';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { listUserIDAll } from '../../../services/apiUsers';
import SafeText from '../../../components/SafeText';
import { LazyLoadImage } from 'react-lazy-load-image-component';

let listVaiTro = [
  { id: 1, name: 'Người đứng tên', value: 'Người đứng tên' },
  { id: 2, name: 'Vợ', value: 'Vợ' },
  { id: 3, name: 'Chồng', value: 'Chồng' },
  { id: 4, name: 'Con ruột', value: 'Con ruột' },
  { id: 5, name: 'Cha/mẹ', value: 'Cha/mẹ' },
  ,
  { id: 6, name: 'Anh/em', value: 'Anh/em' },
  ,
  { id: 7, name: 'Họ hàng', value: 'Họ hàng' },
  ,
  { id: 8, name: 'Người quyết định (không đứng tên)', value: 'Người quyết định (không đứng tên)' },
  ,
  { id: 9, name: 'Môi giới độc quyền', value: 'Môi giới độc quyền' },
  ,
  { id: 10, name: 'Chưa xác định', value: 'Chưa xác định' },
];

export default function AddBds() {
  const inputFile = useRef(null);
  const [showImage, setShowImage] = useState([]);
  const inputFileSo = useRef(null);
  const auth = getCookie('token');
  const [open, setOpen] = useState(0);
  const [checkInfo, setCheckInfo] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [message, setMessage] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [isCheckTrung, setIsCheckTrung] = useState(false);
  const [streetName, setStreetName] = useState(
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124928.46940428336!2d108.36832152803531!3d11.904066867762978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x317112fef20988b1%3A0xad5f228b672bf930!2zVHAuIMSQw6AgTOG6oXQsIEzDom0gxJDhu5NuZywgVmnhu4d0IE5hbQ!5e0!3m2!1svi!2s!4v1727619154488!5m2!1svi!2s',
  );
  const [isChangeData, setIsChangeData] = useState({});
  const [arrResultOld, setArrResultOld] = useState([]);
  const [arrPhone, setArrPhone] = useState(['']);
  const [arrPhoneVaiTro, setArrPhoneVaiTro] = useState(['']);
  const [arrSoLo, setArrSoLo] = useState(['']);
  const [arrSoTo, setArrSoTo] = useState(['']);
  const [arrSoThua, setArrSoThua] = useState(['']);
  const [coords, setCoords] = useState();
  const [imagesAll, setImagesAll] = useState([]);
  const [imageURLSAll, setImageURLsAll] = useState([]);
  const [images, setImages] = useState([]);
  const [imageURLS, setImageURLs] = useState([]);
  const [imagesSo, setImagesSo] = useState([]);
  const [imageURLSSo, setImageURLsSo] = useState([]);
  const [imageURLsUpdate, setImageURLsUpdate] = useState([]);
  const [imageURLsSoUpdate, setImageURLsSoUpdate] = useState([]);
  const [arrHisBds, setArrHisBds] = useState([]);
  const [imageRemove, setImageRemove] = useState([]);
  const [resultBVID, setResultBVID] = useState([]);
  const [phoneNewChu, setPhoneNewChu] = useState({});
  const [warningMessage, setWarningMessage] = useState('');
  const [warningMessagePhone, setWarningMessagePhone] = useState('');
  const [messagePhoneNew, setMessagePhoneNew] = useState('');
  const [arrBDS, setArrBDS] = useState({
    id_user: auth?.id,
    username: auth?.username,
    masp: '',
    tieude: '',
    toado: '',
    sonha: '',
    duong: '',
    huyen: '',
    xa: '',
    tinh: 'Lâm Đồng',
    khuqh: '',
    soto: '',
    sothua: '',
    solo: '',
    sdtchudat: '',
    sdtchudatvaitro: '',
    isbandat: '',
    ischothue: '',
    ishanche: 0,
    isdocquyen: 0,
    rongduong: '',
    quyhoach: '',
    phaply: '',
    huongbds: '',
    loaivitri: '',
    loaibds: '',
    tiennghi: '',
    dactrung: '',
    notenoibo: '',
    notekhach: '',
    dientich: '',
    dientichdatnn: '',
    dientichsan: '',
    ngang: '',
    nganghau: '',
    dai: '',
    sotang: '',
    sophong: '',
    sowc: '',
    giathue: '',
    gia: '',
    anhto: '',
    anhthua: '',
    status: '3',
    isso: 1,
  });

  const [arrOptionSelect, setArrOptionSelect] = useState({});
  const [arrOptionSelectSearch, setArrOptionSelectSearch] = useState({});
  const [resultListUsers, setResultListUsers] = useState([]);
  const [isCheckWifi, setIsCheckWifi] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [message, setMessage] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(location.search);
  const idBds = urlParams.get('u');

  useEffect(() => {
    document.title = 'Bài viết bất động sản';
    fetchIp();
  }, []);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  const fn = async (e) => {
    if (e.key === 'Enter') {
      const result = await geocodeByAddress(streetName);
      const lngLat = await getLatLng(result[0]);
      setCoords(lngLat);
    }
  };

  const fetchIp = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      if (response.status === 200) {
        if (auth['wifi'] !== data.ip && (Number(auth?.permission) === 2 || Number(auth?.permission) === 4)) {
          setIsCheckWifi(false);
        } else {
          setIsCheckWifi(true);
        }
      } else {
        setIsCheckWifi(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSearchOptionSelect = (key, val, keysearch) => {
    if (val) {
      const cleanVal = val.trim().toLowerCase().replace(/\s+/g, ' ');
      const results = arrOptionSelect[key]?.filter((item) => {
        const cleanItem = String(item[keysearch] || '')
          .trim()
          .toLowerCase()
          .replace(/\s+/g, ' ');

        // so sánh chính xác
        return cleanItem === cleanVal;
      });
      const sorted = [...results].sort((a, b) => a.xa.trim().localeCompare(b.xa.trim(), 'vi', { sensitivity: 'base' }));

      setArrOptionSelectSearch({ ...arrOptionSelect, [key]: sorted });
    } else {
      setArrOptionSelectSearch({ ...arrOptionSelect, [key]: arrOptionSelect[key] });
    }
  };

  const getStreets = async () => {
    const resultAPI = await listAllStreets(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, streets: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, streets: resultAPI });
    }
  };
  const getStreetsGroup = async () => {
    const resultAPI = await listAllStreetsGroup(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, streets: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, streets: resultAPI });
    }
    // console.log(resultAPI.filter((item) => item.xa === 'Phường 1')[0]?.phuong_group);
  };

  const getKQH = async () => {
    const resultAPI = await listAllKqhs(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, kqhs: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, kqhs: resultAPI });
    }
  };
  const getQH = async () => {
    const resultAPI = await listAllQhs(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, qhs: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, qhs: resultAPI });
    }
  };
  const getPhaply = async () => {
    const resultAPI = await listAllPhaply(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, phaply: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, phaply: resultAPI });
    }
  };
  const getHuongBds = async () => {
    const resultAPI = await listAllHuongBds(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, huongbds: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, huongbds: resultAPI });
    }
  };
  const getLoaiVitri = async () => {
    const resultAPI = await listAllVitri(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, loaivitri: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, loaivitri: resultAPI });
    }
  };
  const getLoaiBDS = async () => {
    const resultAPI = await listAllLoaibds(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, loaibds: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, loaibds: resultAPI });
    }
  };
  const getTiennghi = async () => {
    const resultAPI = await listAllTiennghi(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, tiennghi: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, tiennghi: resultAPI });
    }
  };
  const getDactrung = async () => {
    const resultAPI = await listAllDactrung(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, dactrung: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, dactrung: resultAPI });
    }
  };

  const uniqueData = (data, key) => {
    const seen = new Set();

    const cleaned = data
      .map((item) => {
        let val = item[key];
        if (!val) return null; // bỏ null, undefined
        val = String(val).trim().replace(/\s+/g, ' '); // bỏ khoảng trắng thừa
        return { ...item, [key]: val };
      })
      .filter((item) => item && item[key] !== ''); // bỏ rỗng sau khi clean

    const unique = cleaned.filter((item) => {
      const val = item[key].toLowerCase();
      if (seen.has(val)) return false;
      seen.add(val);
      return true;
    });

    // sắp xếp theo số trong chuỗi
    unique.sort((a, b) => {
      const numA = parseInt(a[key].match(/\d+/)?.[0] || 0, 10);
      const numB = parseInt(b[key].match(/\d+/)?.[0] || 0, 10);
      return numB - numA;
    });

    return unique;
  };
  const removeDataBds = (data, key, index) => {
    const updatedData = data.filter((item, i) => i !== index);
    setArrBDS({
      ...arrBDS,
      [key]: updatedData.join(','),
    });
  };

  const checkText = (data1, data2) => {
    const textArray1 = data1.split(','); // Split data1 into an array
    const textArray2 = data2.split(','); // Split data2 into an array

    const isMatch = textArray1.some((text) => textArray2.includes(text));

    return isMatch;
  };

  const reset = () => {
    setImageURLsAll([]);
    setImagesAll([]);
    setArrPhone(['']);
    setArrPhoneVaiTro(['']);
    setArrSoThua(['']);
    setArrSoTo(['']);
    setImages([]);
    setImageURLs([]);
    setImagesSo([]);
    setImageURLsSo([]);
    setImageURLsUpdate([]);
    setImageURLsSoUpdate([]);
    setImageRemove([]);
    setIsChangeData({});
    setArrHisBds([]);
    setWarningMessagePhone('');
    setArrBDS({
      id_user: auth?.id,
      username: auth?.username,
      masp: '',
      tieude: '',
      toado: '',
      sonha: '',
      duong: '',
      huyen: '',
      xa: '',
      tinh: 'Lâm Đồng',
      khuqh: '',
      soto: '',
      sothua: '',
      solo: '',
      sdtchudat: '',
      sdtchudatvaitro: '',
      isbandat: 0,
      ischothue: 0,
      ishanche: 0,
      isdocquyen: 0,
      rongduong: '',
      quyhoach: '',
      phaply: '',
      huongbds: '',
      loaivitri: '',
      loaibds: '',
      tiennghi: '',
      dactrung: '',
      notenoibo: '',
      notekhach: '',
      dientich: '',
      dientichdatnn: '',
      dientichsan: '',
      ngang: '',
      nganghau: '',
      dai: '',
      sotang: '',
      sophong: '',
      sowc: '',
      giathue: '',
      gia: '',
      anhto: '',
      anhthua: '',
      status: '3',
    });
  };

  const fetchImages = async (imageNames) => {
    if (imageNames) {
      const res = await fetch(`${API_URL}/imgshop-thumbnail?names=${imageNames}`);
      const data = await res.json();
      setImageURLsAll(data);
    } else {
      setImageURLsAll([]);
    }
  };

  const getBdsId = async (id) => {
    const resultID = await getIdBds(id);
    if (resultID.length > 0) {
      if (resultID[0]['status'] === '3') {
        // console.log(resultID);
        setIsDisabled(false);
        setCheckInfo(true);
        setArrBDS({
          id: resultID[0].id,
          id_user: auth?.id,
          username: auth?.username,
          masp: resultID[0].masp,
          tieude: resultID[0].tieude,
          toado: resultID[0].toado,
          sonha: resultID[0].sonha,
          duong: resultID[0].duong,
          huyen: resultID[0].huyen,
          xa: resultID[0].xa,
          tinh: resultID[0].tinh,
          khuqh: resultID[0].khuqh,
          soto: resultID[0].soto,
          sothua: resultID[0].sothua,
          solo: resultID[0].solo,
          sdtchudat: resultID[0].sdtchudat,
          sdtchudatvaitro: resultID[0].sdtchudatvaitro,
          isbandat: resultID[0].isbandat,
          ischothue: resultID[0].ischothue,
          rongduong: resultID[0].rongduong,
          quyhoach: resultID[0].quyhoach,
          phaply: resultID[0].phaply,
          huongbds: resultID[0].huongbds,
          loaivitri: resultID[0].loaivitri,
          loaibds: resultID[0].loaibds,
          tiennghi: resultID[0].tiennghi,
          dactrung: resultID[0].dactrung,
          notenoibo: resultID[0].notenoibo,
          notekhach: resultID[0].notekhach,
          dientich: resultID[0].dientich,
          dientichdatnn: resultID[0].dientichdatnn,
          dientichsan: resultID[0].dientichsan,
          ngang: resultID[0].ngang,
          nganghau: resultID[0].nganghau,
          dai: resultID[0].dai,
          sotang: resultID[0].sotang,
          sophong: resultID[0].sophong,
          sowc: resultID[0].sowc,
          giathue: resultID[0].giathue ? resultID[0].giathue : 0,
          gia: resultID[0].gia ? resultID[0].gia / 1000000000 : 0,
          anhto: resultID[0].anhto,
          anhthua: resultID[0].anhthua,
          status: '3',
          isso: resultID[0].isso,
        });

        // handleSearchOptionSelect('streets', resultID[0].xa, resultID[0].isso === 1 ? 'xa': 'phuong_group');
        setArrPhone(resultID[0].sdtchudat?.split(','));
        setArrPhoneVaiTro(resultID[0].sdtchudatvaitro?.split(',') || ['']);
        setArrSoTo(resultID[0].soto ? resultID[0].soto?.split(',') : []);
        setArrSoThua(resultID[0].sothua ? resultID[0].sothua?.split(',') : []);
        setArrSoLo(resultID[0].solo ? resultID[0].solo?.split(',') : ['']);
        setImageURLsUpdate(resultID[0].anhto ? resultID[0].anhto?.split(',') : []);
        setImageURLsSoUpdate(resultID[0].anhthua ? resultID[0].anhthua?.split(',') : []);
        // setImageURLsAll(resultID[0].anhto ? resultID[0].anhto?.split(',') : []);
        fetchImages(resultID[0].anhto ? resultID[0].anhto : '');
      } else {
        setCheckInfo(false);
      }
    } else {
      setCheckInfo(false);
    }

    const checkHistory = await getHistoryBDS('edit', idBds);
    if (checkHistory.length > 0) {
      setArrHisBds(checkHistory);
    }
  };

  const listUserAll = async (isstatus = '', username = '', pages = 1) => {
    const resultUserAll = await listUserIDAll(isstatus, username, pages, 500);
    if (resultUserAll.length > 0) {
      setResultListUsers(resultUserAll);
    } else {
      setResultListUsers([]);
    }
  };
  useEffect(() => {
    if (idBds) {
      getBdsId(idBds);
      getStreetsGroup();
    }
    listUserAll();
  }, [idBds]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const subUpdateDefault = async (e) => {
    e.preventDefault();
    if (arrBDS.duong === '') {
      setWarningMessage('Bạn chưa nhập tên Đường');
    } else if (arrBDS.huongbds === '') {
      setWarningMessage('Bạn chưa nhập Hướng BĐS');
    } else if (arrBDS.loaivitri === '') {
      setWarningMessage('Bạn chưa nhập Vị Trí');
    } else if (arrBDS.loaibds === '') {
      setWarningMessage('Bạn chưa nhập Loại BĐS');
    } else if (arrBDS.gia === '' && arrBDS.isbandat > 0) {
      setWarningMessage('Bạn chưa nhập Giá');
    } else {
      const roleEmptyIndex = arrPhoneVaiTro.findIndex((r) => !r);

      if (roleEmptyIndex !== -1) {
        alert(`Dòng ${roleEmptyIndex + 1}: Chưa chọn vai trò sđt`);
        return;
      }

      setLoading(true);
      setIsDisabled(true);
      const formData = new FormData();
      const filtered = imageURLSAll
        .map((item) => {
          if (item instanceof File) {
            return item;
          } else if (item && typeof item === 'object' && 'name' in item && typeof item.name === 'string') {
            return item.name;
          } else if (typeof item === 'string') {
            return item;
          } else {
            return null;
          }
        })
        .filter((el) => el !== null);
      let arrAnhTo = [...filtered];
      let arrAnhThua = [...imageURLsSoUpdate];
      if (imagesAll.length > 0) {
        arrAnhTo = [];
        imagesAll.forEach((image, i) => {
          if (image instanceof File) {
            let extension = image.name.split('.').pop().toLowerCase();

            // Ép lại định dạng đuôi nếu là jfif hoặc không rõ
            if (extension === 'jfif') {
              extension = 'jpg';
            } else if (!['jpg', 'jpeg', 'png', 'webp'].includes(extension)) {
              extension = 'jpg'; // fallback nếu là đuôi lạ
            }

            const timestampName = `${i}_img_${Date.now()}.${extension}`;
            formData.append('image', image, timestampName);
            arrAnhTo.push(timestampName);
          } else if (typeof image === 'object' && image.name) {
            arrAnhTo.push(image['name']);
          } else if (typeof image === 'string') {
            arrAnhTo.push(image);
          }
        });
      }
      // console.log(233, arrAnhTo, imagesAll);
      // imagesSo.forEach((image, i) => {
      //   const extension = image.name.split('.').pop();
      //   let timestamp = i + '_to_' + Date.now() + '.' + extension;
      //   arrAnhThua.push(timestamp);
      //   formData.append('image', image, timestamp);
      // });
      imagesSo.forEach((image, i) => {
        let extension = image.name?.split('.').pop().toLowerCase() || 'jpg';

        // Chuẩn hóa extension
        const validExtensions = ['jpg', 'jpeg', 'png', 'webp', 'gif'];
        if (extension === 'jfif') {
          extension = 'jpg';
        } else if (!validExtensions.includes(extension)) {
          extension = 'jpg'; // fallback nếu đuôi không hợp lệ
        }

        const timestamp = `${i}_to_${Date.now()}.${extension}`;
        arrAnhThua.push(timestamp);
        formData.append('image', image, timestamp);
      });
      let arrBDSSV = {
        ...arrBDS,
        gia: arrBDS.gia * 1000000000,
        giathue: arrBDS?.giathue,
        anhto: arrAnhTo.join(','),
        anhthua: arrAnhThua.join(','),
      };
      // console.log(arrBDSSV);
      formData.append('data', JSON.stringify(arrBDSSV));
      formData.append('imgremove', JSON.stringify(imageRemove));
      const upload = await updateBds(formData);
      if (upload.message === 'OK') {
        await historyBds({
          data: {
            noidung: JSON.stringify(isChangeData).slice(1, -1),
            username: auth?.username,
            user_id: auth?.id,
            truong: 'edit',
            id_bds: idBds,
          },
        });
        reset();
        navigate('/dsbds');
      } else {
        setLoading(false);
        setIsDisabled(false);
      }
    }
  };
  const filterValidObjects = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => {
        if (value === null || value === undefined) return false;
        if (typeof value === 'string' && value.trim() === '') return false;
        if (Array.isArray(value) && value.length === 0) return false;
        if (typeof value === 'object' && Object.keys(value).length === 0) return false;
        return true;
      }),
    );
  };

  const subUpdateSDTNEW = async () => {
    if (resultBVID.length > 0 && validatePhoneNumber(phoneNewChu[0])) {
      const xaCheck =
        arrBDS.isso === 1
          ? resultBVID[0]['xa']
          : formatPhuongGroup(arrOptionSelectSearch?.streets, resultBVID[0]['xa']);
      const checkTrungChuOld = await checkPhoneChu(
        phoneNewChu[0].slice(0, 10),
        resultBVID[0]['soto'],
        resultBVID[0]['sothua'],
        xaCheck,
      );
      if (checkTrungChuOld.length > 0) {
        setMessagePhoneNew('Bạn thêm số mới TRÙNG với số chủ cũ');
      } else {
        setLoading(true);
        const formData = new FormData();
        let arr = {
          id_bds: resultBVID[0]['id'],
          status: 1,
          id_user: auth?.id,
          sdtchudat: phoneNewChu[0] ? phoneNewChu[0] : '',
          sdtchudatvaitro: arrPhoneVaiTro[0] ? arrPhoneVaiTro[0] : '',
        };
        let arrBDSSV = { id: resultBVID[0]['id'], status: '1' };
        formData.append('data', JSON.stringify(filterValidObjects(arr)));
        const result = await updateBds({ data: JSON.stringify(filterValidObjects(arrBDSSV)) });
        if (result.message === 'OK') {
          const upload = await addCmt(formData);
          if (upload.message === 'OK') {
            setMessagePhoneNew('Thành Công');
            reset();
            // navigate('/dsbds');
            setPhoneNewChu({});
            setLoading(false);
            setTimeout(() => {
              setMessagePhoneNew('');
              setResultBVID([]);
            }, 3000);
          } else {
            setMessagePhoneNew('');
            setLoading(false);
          }
        } else {
          setMessagePhoneNew('');
          setLoading(false);
        }
      }
    } else {
      setMessagePhoneNew('Bạn nhập số điện thoại không đủ 10 số');
    }
  };

  const subUpdateSDTNEW2 = async (resultBVID, index) => {
    // console.log(resultBVID);

    if (validatePhoneNumber(phoneNewChu[index])) {
      const xaCheck =
        arrBDS.isso === 1 ? resultBVID['xa'] : formatPhuongGroup(arrOptionSelectSearch?.streets, resultBVID['xa']);
      const checkTrungChuOld = await checkPhoneChu(
        phoneNewChu[index].slice(0, 10),
        resultBVID['soto'],
        resultBVID['sothua'],
        xaCheck,
      );
      if (checkTrungChuOld.length > 0) {
        setMessagePhoneNew('Bạn thêm số mới TRÙNG với số chủ cũ');
      } else {
        setLoading(true);
        const formData = new FormData();
        let arr = {
          id_bds: resultBVID['id'],
          status: 1,
          id_user: auth?.id,
          sdtchudat: phoneNewChu[index] ? phoneNewChu[index] : '',
          sdtchudatvaitro: arrPhoneVaiTro[index] ? arrPhoneVaiTro[index] : '',
        };
        let arrBDSSV = { id: resultBVID['id'], status: '1' };
        formData.append('data', JSON.stringify(filterValidObjects(arr)));
        const result = await updateBds({ data: JSON.stringify(filterValidObjects(arrBDSSV)) });
        if (result.message === 'OK') {
          const upload = await addCmt(formData);
          if (upload.message === 'OK') {
            setMessagePhoneNew('Thành Công');
            reset();
            // navigate('/dsbds');
            setPhoneNewChu({});
            setArrResultOld([]);
            setLoading(false);
            setTimeout(() => {
              setResultBVID([]);
              setMessagePhoneNew('');
            }, 3000);
          } else {
            setMessagePhoneNew('');
            setLoading(false);
          }
        } else {
          setMessagePhoneNew('');
          setLoading(false);
        }
      }
    } else {
      setMessagePhoneNew('Bạn nhập số điện thoại không đủ 10 số');
    }
  };

  const subAddDefault = async (e) => {
    e.preventDefault();
    if (arrBDS.duong === '') {
      setWarningMessage('Bạn chưa nhập tên Đường');
    } else if (arrBDS.huongbds === '') {
      setWarningMessage('Bạn chưa nhập Hướng BĐS');
    } else if (arrBDS.loaivitri === '') {
      setWarningMessage('Bạn chưa nhập Vị Trí');
    } else if (arrBDS.loaibds === '') {
      setWarningMessage('Bạn chưa nhập Loại BĐS');
    } else if (arrBDS.loaibds === '') {
      setWarningMessage('Bạn chưa nhập Loại BĐS');
    } else if (arrBDS.gia === '' && arrBDS.isbandat > 0) {
      setWarningMessage('Bạn chưa nhập Giá');
    } else {
      const roleEmptyIndex = arrPhoneVaiTro.findIndex((r) => !r);

      if (roleEmptyIndex !== -1) {
        alert(`Dòng ${roleEmptyIndex + 1}: Chưa chọn vai trò sđt`);
        return;
      }

      setLoading(true);
      setIsDisabled(true);
      const formData = new FormData();
      let arrAnhTo = [];
      let arrAnhThua = [];
      // images.forEach((image, i) => {
      //   const extension = image.name.split('.').pop();
      //   let timestamp = i + '_img_' + Date.now() + '.' + extension;
      //   arrAnhTo.push(timestamp);
      //   formData.append('image', image, timestamp);
      // });

      images.forEach((image, i) => {
        let extension = image.name?.split('.').pop().toLowerCase() || 'jpg';

        // Chuẩn hóa extension
        const validExtensions = ['jpg', 'jpeg', 'png', 'webp', 'gif'];
        if (extension === 'jfif') {
          extension = 'jpg';
        } else if (!validExtensions.includes(extension)) {
          extension = 'jpg'; // fallback nếu đuôi không hợp lệ
        }

        const timestamp = `${i}_img_${Date.now()}.${extension}`;
        arrAnhTo.push(timestamp);
        formData.append('image', image, timestamp);
      });
      // imagesSo.forEach((image, i) => {
      //   const extension = image.name.split('.').pop();
      //   let timestamp = i + '_to_' + Date.now() + '.' + extension;
      //   arrAnhThua.push(timestamp);
      //   formData.append('image', image, timestamp);
      // });

      imagesSo.forEach((image, i) => {
        let extension = image.name?.split('.').pop().toLowerCase() || 'jpg';

        // Chuẩn hóa extension
        const validExtensions = ['jpg', 'jpeg', 'png', 'webp', 'gif'];
        if (extension === 'jfif') {
          extension = 'jpg';
        } else if (!validExtensions.includes(extension)) {
          extension = 'jpg'; // fallback nếu đuôi không hợp lệ
        }

        const timestamp = `${i}_to_${Date.now()}.${extension}`;
        arrAnhThua.push(timestamp);
        formData.append('image', image, timestamp);
      });
      let arrBDSSV = {
        ...arrBDS,
        gia: arrBDS.gia * 1000000000,
        giathue: arrBDS?.giathue,
        anhto: arrAnhTo.join(','),
        anhthua: arrAnhThua.join(','),
      };
      formData.append('data', JSON.stringify(arrBDSSV));
      const upload = await addBds(formData);

      if (upload.message === 'OK') {
        scrollToTop();
        reset();
        setLoading(false);
        setIsDisabled(false);
        setMessage('Thành Công');
        setTimeout(() => {
          setMessage('');
        }, 6000);
        navigate(`/addbds?u=${upload.ibv}`, { replace: true });
        setCheckInfo(true);
      } else {
        setLoading(false);
        setIsDisabled(false);
        setMessage('Thất Bại');
      }
      setWarningMessage('');
    }
  };

  const changePhone = (e, i) => {
    let value = e.target.value;
    let updatedData = arrPhone.map((item, index) => {
      if (index === i) {
        return value;
      }
      return item;
    });
    setArrPhone(updatedData);
    setArrBDS({ ...arrBDS, sdtchudat: updatedData.join(',') });
    setIsChangeData({ ...isChangeData, 'số chủ đất': updatedData.join(',') });
  };
  const changePhoneVaiTro = (value, i) => {
    let updatedData = arrPhoneVaiTro.map((item, index) => (index === i ? value : item));

    setArrPhoneVaiTro(updatedData);
    setArrBDS((prev) => ({
      ...prev,
      sdtchudatvaitro: updatedData.join(','),
    }));
    setIsChangeData((prev) => ({
      ...prev,
      'vai trò số chủ đất': updatedData.join(','),
    }));
  };

  const changeSoTo = (e, i) => {
    let value = e.target.value;
    let updatedData = arrSoTo.map((item, index) => {
      if (index === i) {
        return value;
      }
      return item;
    });
    setArrSoTo(updatedData);
    setArrBDS({ ...arrBDS, soto: updatedData.join(',') });
    setIsChangeData({ ...isChangeData, 'số tờ': updatedData.join(',') });
  };
  const changeSoThua = (e, i) => {
    let value = e.target.value;
    let updatedData = arrSoThua.map((item, index) => {
      if (index === i) {
        return value;
      }
      return item;
    });
    setArrSoThua(updatedData);
    setArrBDS({ ...arrBDS, sothua: updatedData.join(',') });
    setIsChangeData({ ...isChangeData, 'số thửa': updatedData.join(',') });
  };
  const changeSoLo = (e, i) => {
    let value = e.target.value;
    let updatedData = arrSoLo.map((item, index) => {
      if (index === i) {
        return value;
      }
      return item;
    });
    setArrSoLo(updatedData);
    setArrBDS({ ...arrBDS, solo: updatedData.join(',') });
    setIsChangeData({ ...isChangeData, 'số lô': updatedData.join(',') });
  };

  // const removePhone = (index) => {
  //   const arrRemove = arrPhone.filter((_, i) => i !== index) || [];
  //   const arrRemoveVaiTro = arrPhoneVaiTro.filter((_, i) => i !== index) || [];
  //   console.log(arrPhoneVaiTro, arrRemove, index);
  //   setArrPhone(arrRemove);
  //   setArrPhoneVaiTro(arrRemoveVaiTro);
  // };

  const removePhone = (index) => {
    setArrPhone((prevPhone) => {
      const newPhone = prevPhone.filter((_, i) => i !== index);

      setArrPhoneVaiTro((prevRole) => {
        const newRole = prevRole.filter((_, i) => i !== index);

        setArrBDS((prev) => ({
          ...prev,
          sdtchudat: newPhone.join(','),
          sdtchudatvaitro: newRole.join(','),
        }));

        return newRole;
      });

      return newPhone;
    });
  };
  const removeToThua = (index) => {
    const arrRemoveThua = arrSoThua.filter((_, i) => i !== index) || [];
    setArrSoThua(arrRemoveThua);
    const arrRemoveTo = arrSoTo.filter((_, i) => i !== index) || [];
    setArrSoTo(arrRemoveTo);
  };

  const removeSoLo = (index) => {
    const arrRemoveSoLo = arrSoLo.filter((_, i) => i !== index) || [];
    setArrSoLo(arrRemoveSoLo);
  };

  // HÌNH ẢNH
  const onButtonClickFileImage = () => {
    // `current` points to the mounted file input element
    inputFile.current.click();
  };

  const onFilechange = (e) => {
    let tempArr = [];
    let tempFileArr = [];
    setIsChangeData({ ...isChangeData, 'thêm ảnh': 'Đã thêm hình ảnh' });
    if (images.length + imageURLsUpdate.length + e.target.files.length > 20) {
      alert('Bạn chỉ được thêm tối đa 20 ảnh');
      return;
    }
    [...e.target.files].forEach((file) => {
      if (file.type.startsWith('image/')) {
        tempArr.push(URL.createObjectURL(file));
        tempFileArr.push(file);
      } else {
        alert('Bạn không được thêm video hoặc tập tin');
        return;
      }
    });
    setImageURLs([...imageURLS, ...tempArr]);
    setImages([...images, ...tempFileArr]);

    let imageupdate = [...imageURLS, ...tempArr];
    let arrAnh = [...imageURLSAll, ...tempArr];
    // console.log(arrAnh);
    setImageURLsAll(arrAnh);

    let imageFile = [...images, ...tempFileArr];
    let arrAnhFile = [...imageURLSAll, ...tempFileArr];
    setImagesAll(arrAnhFile);
  };

  // xoa ảnh
  const removeImage = (index) => {
    const arrRemove = imageURLS.filter((_, i) => i !== index) || [];
    const arrRemoveFile = images.filter((_, i) => i !== index) || [];
    setImageURLs(arrRemove);
    setImages(arrRemoveFile);
  };
  const removeImageUpdate = (index) => {
    const arrRemove = imageURLsUpdate.filter((_, i) => i !== index) || [];
    const idRemove = imageURLsUpdate.filter((_, i) => i === index) || [];
    setImageRemove([...imageRemove, ...idRemove]);
    setImageURLsUpdate(arrRemove);
  };

  const removeImageUpdateAll = (index) => {
    const arrRemove = imageURLSAll.filter((_, i) => i !== index) || [];
    const idRemove = imagesAll.filter((_, i) => i === index) || [];
    setImageRemove([...imageRemove, ...idRemove]);
    setImagesAll(arrRemove);
    setImageURLsAll(arrRemove);
    setIsChangeData({ ...isChangeData, 'xoá ảnh': 'Đã xoá ảnh hình ảnh' });
  };

  // HÌNH ẢNH SỔ
  const onButtonClickFileImageSo = () => {
    // `current` points to the mounted file input element
    inputFileSo.current.click();
  };

  const onFilechangeSo = (e) => {
    let tempArr = [];
    let tempFileArr = [];
    if (imagesSo.length + imageURLsSoUpdate.length + e.target.files.length > 5) {
      alert('Bạn chỉ được thêm tối đa 5 ảnh hoặc tập tin');
      return;
    }
    [...e.target.files].forEach((file) => {
      if (file.type.startsWith('image/')) {
        tempArr.push(URL.createObjectURL(file));
        tempFileArr.push(file);
      } else if (file.type.startsWith('video/')) {
        alert('Bạn không được thêm video');
        return;
      } else {
        tempArr.push('');
        tempFileArr.push(file);
      }
    });
    setImageURLsSo([...imageURLSSo, ...tempArr]);
    setImagesSo([...imagesSo, ...tempFileArr]);
  };

  // xoa ảnh
  const removeImageSo = (index) => {
    const arrRemove = imageURLSSo.filter((_, i) => i !== index) || [];
    const arrRemoveFile = imagesSo.filter((_, i) => i !== index) || [];
    setImageURLsSo(arrRemove);
    setImagesSo(arrRemoveFile);
  };

  const removeImageSoUpdate = (index) => {
    const arrRemove = imageURLsSoUpdate.filter((_, i) => i !== index) || [];
    const idRemove = imageURLsSoUpdate.filter((_, i) => i === index) || [];
    setImageRemove([...imageRemove, ...idRemove]);
    setImageURLsSoUpdate(arrRemove);
  };

  const typeImg = (str) => {
    const lastIndex = str.lastIndexOf('.');
    const result = str.substring(lastIndex + 1);
    if (result === 'png' || result === 'jpg' || result === 'jpeg') {
      return true;
    } else {
      return false;
    }
  };

  const extractSrcFromIframe = (text) => {
    const regex = /<iframe.*?src="(.*?)".*?>/;
    const matches = text.match(regex);
    if (matches && matches.length > 1) {
      const src = matches[1];
      return src;
    }
    return null;
  };

  const getSrcGGMap = (text) => {
    const texts = extractSrcFromIframe(text);
    return texts;
  };

  const validatePhoneNumber = (text) => {
    // const match = text?.match(/^\d{10}/); // Kiểm tra 10 chữ số đầu tiên của chuỗi
    // return match !== null;
    return /^\d{10}/.test(text?.trim() ?? '');
  };

  const formatPhuongGroup = (data = [], groupName = '') => {
    if (!Array.isArray(data) || data.length === 0) return '';
    if (!groupName || groupName.trim() === '') return '';

    // Lọc theo phuong_group chỉ định, bỏ trống/null
    const filtered = data.filter(
      (item) =>
        item && item.phuong_group && item.xa && item.phuong_group.trim() === groupName.trim() && item.xa.trim() !== '',
    );

    if (filtered.length === 0) return '';

    // Lấy danh sách xã duy nhất
    const xaList = [...new Set(filtered.map((item) => item.xa.trim()).filter(Boolean))];

    // Gộp kết quả thành chuỗi
    return [groupName.trim(), ...xaList].join(',');
  };

  const handleCheckPhoneChu = async () => {
    const roleEmptyIndex = arrPhoneVaiTro.findIndex((r) => !r);

    if (roleEmptyIndex !== -1) {
      alert(`Dòng ${roleEmptyIndex + 1}: Chưa chọn vai trò`);
      return;
    }

    setPhoneNewChu({});
    setMessagePhoneNew('');
    setResultBVID([]);
    setArrResultOld([]);
    if (arrPhone.length > 0 && arrSoTo[0] !== '' && arrBDS.xa !== '') {
      let isTrung = false;

      const textSoTo = arrSoTo.length > 1 ? arrSoTo.join(',') : arrSoTo[0] || '';
      const textSoThua = arrSoThua.length > 1 ? arrSoThua.join(',') : arrSoThua[0] || '';
      // console.log(textSoTo, textSoThua);
      for (const row of arrPhone) {
        if (validatePhoneNumber(row)) {
          try {
            const xaCheck =
              arrBDS.isso === 1 ? arrBDS.xa : formatPhuongGroup(arrOptionSelectSearch?.streets, arrBDS.xa);
            const result = await checkPhoneChu(row.slice(0, 10), textSoTo, textSoThua, xaCheck);

            // console.log(result);
            if (result.length > 0) {
              setResultBVID(result);
              isTrung = true;
              break; // Nếu đã trùng thì dừng vòng lặp
            } else {
              setResultBVID([]);
            }
          } catch (error) {
            console.error('Lỗi khi check SĐT:', error);
          }
        } else {
          setWarningMessagePhone('Bạn nhập số điện thoại không đủ 10 số');
          setIsDisabled(true);
          return;
        }
      }

      if (isTrung) {
        setWarningMessagePhone('BÀI VIẾT NÀY HIỆN ĐÃ CÓ TRÊN HỆ THỐNG (dựa trên Số Tờ/Thửa, Phường/xã & SĐT)');
        setIsDisabled(true);
        setArrResultOld([]);
      } else {
        const xaCheck = arrBDS.isso === 1 ? arrBDS.xa : formatPhuongGroup(arrOptionSelectSearch?.streets, arrBDS.xa);
        const resultOLD = await checkPhoneChu('', textSoTo, textSoThua, xaCheck);

        if (resultOLD.length > 0) {
          const arr = resultOLD.sort((a, b) => {
            const dateA = new Date(a.create_date.replace('T', ' '));
            const dateB = new Date(b.create_date.replace('T', ' '));
            return dateB - dateA;
          });
          setArrResultOld(arr);
          // console.log(123, arr);
          setIsDisabled(true);
          setIsCheckTrung(true);
        } else {
          for (const row of arrPhone) {
            if (validatePhoneNumber(row)) {
              try {
                const resultTrungSo = await checkPhoneChu(row.slice(0, 10), '', '', '');
                // console.log(resultTrungSo);
                const arr = resultTrungSo.sort((a, b) => {
                  const dateA = new Date(a.create_date.replace('T', ' '));
                  const dateB = new Date(b.create_date.replace('T', ' '));
                  return dateB - dateA;
                });
                setArrResultOld(arr);
                // console.log(1234, arr);
              } catch (error) {
                console.error('Lỗi khi check SĐT:', error);
              }
            } else {
              setWarningMessagePhone('Bạn nhập số điện thoại không đủ 10 số');
              setIsDisabled(true);
              return;
            }
          }
          setWarningMessagePhone(
            'Có thể nhập ! Chưa có thông tin BĐS cùng SĐT chủ này ! (dựa trên Số Tờ/Thửa, Phường/xã & SĐT)',
          );
          setIsDisabled(false);
          setIsCheckTrung(false);
        }
      }
    } else {
      setWarningMessagePhone('Bạn chưa nhập Số Tờ / Số Thửa hoặc Phường/xã');
      setIsDisabled(true);
      setArrResultOld([]);
    }
  };
  const draggedItem = useRef(null);

  const handleDragStart = (index) => {
    draggedItem.current = index;
    document.body.classList.add('grabbing');
  };

  const handleDragEnter = (index) => {
    const currentIndex = draggedItem.current;
    if (currentIndex === index) return;

    const updated = [...imageURLS];
    const [moved] = updated.splice(currentIndex, 1);
    updated.splice(index, 0, moved);
    draggedItem.current = index;
    setImageURLs(updated);

    const updateImage = [...images];
    const [item] = updateImage.splice(currentIndex, 1);
    updateImage.splice(index, 0, item);
    draggedItem.current = index;
    setImages(updateImage);
  };

  const handleDragEnterUpdate = (index) => {
    const currentIndex = draggedItem.current;
    if (currentIndex === index) return;

    const updated1 = [...imageURLSAll];
    const [moved1] = updated1.splice(currentIndex, 1);
    updated1.splice(index, 0, moved1);
    draggedItem.current = index;
    setImageURLsAll(updated1);

    if (imagesAll.length > 0) {
      const updateImage1 = [...imagesAll];
      const [item] = updateImage1.splice(currentIndex, 1);
      updateImage1.splice(index, 0, item);
      draggedItem.current = index;

      setImagesAll(updateImage1);
    }
    // console.log(imagesAll);

    const updated = [...imageURLsUpdate];
    const [moved] = updated.splice(currentIndex, 1);
    updated.splice(index, 0, moved);
    draggedItem.current = index;
    setImageURLsUpdate(updated);
  };

  const handleDragEnd = () => {
    draggedItem.current = null;
    document.body.classList.remove('grabbing');
  };

  const handleChangePhoneChu = (index, e) => {
    setPhoneNewChu({
      ...phoneNewChu,
      [index]: e.target.value, // chỉ thay đổi ô được nhập
    });
  };

  return (
    <div className="grid grid-cols-1">
      {message === 'Thành Công' && (
        <Alert
          icon={<BellAlertIcon className="h-5 w-5" />}
          className="rounded-none border-l-4 border-[#2ec946] bg-[#2ec946]/10 font-medium text-[#2ec946] flex items-center"
        >
          <b>THÊM TIN THÀNH CÔNG</b>
        </Alert>
      )}

      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70">
          <div className="relative w-32 h-32">
            {/* Viền xoay */}
            <div className="absolute inset-0 rounded-full border-4 border-yellow-500 border-t-transparent animate-spin"></div>

            {/* Logo ở giữa */}
            <div className="absolute inset-4 rounded-full bg-yellow-100/70 shadow-[0_0_20px_5px_rgba(250,204,21,0.6)] flex items-center justify-center ">
              <img
                src={imgDF.default.logoklandload} // Thay đường dẫn logo tại đây
                alt="Logo"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      )}
      <div>
        <Card className="p-2">
          <h3 className="font-bold mb-2">THÊM BÀI VIẾT BẤT ĐỘNG SẢN</h3>
          <Alert
            color={message === 'Thành Công' ? 'green' : 'red'}
            className="mb-2"
            open={openAlert}
            onClose={() => setOpenAlert(false)}
          >
            {message === 'Thành Công' ? 'Cập Nhật Thành Công' : 'Cập Nhật Thất Bại'}
          </Alert>
          <div className="grid gap-4">
            <Input
              value={arrBDS?.tieude}
              placeholder="Thêm Tiêu Đề"
              required
              className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
              labelProps={{
                className: 'hidden',
              }}
              onChange={(e) => {
                setArrBDS({ ...arrBDS, tieude: e.target.value });
                setIsChangeData({ ...isChangeData, 'tiêu đề': e.target.value });
              }}
            />
            <div className="grid border border-gray-400 rounded-md">
              <div className="font-bold border-b-2 p-2 border-gray-400">TỌA ĐỘ GOOGLE MAP</div>
              <div className="grid gap-2 p-3">
                <div>
                  <label className="flex items-end gap-1 text-sm mb-1">
                    <b>Dán mã nhúng Google Map</b>{' '}
                    <a href={imgDF.default.hdgooglemap} className="text-blue-600 cursor-pointer" target="_blank">
                      (Xem hướng dẫn)
                    </a>
                  </label>

                  <Input
                    // value={arrBDS?.toado}
                    placeholder="Dán mã nhúng google map "
                    className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                    labelProps={{
                      className: 'hidden',
                    }}
                    onChange={(e) => {
                      setArrBDS({ ...arrBDS, toado: getSrcGGMap(e.target.value) });
                      setIsChangeData({ ...isChangeData, 'tọa độ': getSrcGGMap(e.target.value) });
                    }}
                    onKeyPress={fn}
                  />
                  <i className="text-xs text-gray-600">Copy mã nhúng google tại nút chia sẻ</i>
                </div>
                <div>
                  <label className="flex items-end gap-1 text-sm mb-1">
                    <b>Bản đồ vị trí</b>
                  </label>
                  <iframe
                    src={arrBDS?.toado ? arrBDS?.toado : streetName}
                    width="100%"
                    height="450"
                    // style="border:0;"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* Địa chỉ BĐS - Nhập giống đúng như trên Sổ */}
            <div className="grid border border-gray-400 rounded-md">
              <div className="font-bold border-b-2 border-gray-400 p-2">Địa chỉ BĐS - Nhập giống đúng như trên Sổ</div>
              <div className="gap-4 p-1">
                <div>
                  <label className="flex items-end gap-1 text-xl mb-1">
                    <b className="text-red-500">
                      Chọn Sổ Cũ - Sổ Mới? <b className="text-red-500">*</b> ( Vui lòng chọn chính xác tháng/năm trên sổ
                      )
                    </b>
                  </label>
                </div>
                <div>
                  <div>
                    <Checkbox
                      label={
                        <b className={`${arrBDS.isso === 1 ? 'text-green-500 font-bold' : 'text-black font-bold'}`}>
                          Sổ Cũ <b className="text-red-500">(Trước tháng 7 năm 2025)</b>
                        </b>
                      }
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, isso: e.target.checked ? 1 : 2, xa: '', huyen: '', duong: '' });
                        // setIsChangeData({ ...isChangeData, 'bán đất': e.target.checked ? 'có' : 'không' });
                      }}
                      color={arrBDS.isso === 1 ? 'green' : ''}
                      checked={arrBDS.isso === 1}
                    />
                  </div>
                  <div>
                    <Checkbox
                      label={
                        <b className={`${arrBDS.isso === 2 ? 'text-green-500 font-bold' : 'text-black font-bold'}`}>
                          Sổ Mới <b className="text-red-500">(từ ngày 1/7 năm 2025)</b>
                        </b>
                      }
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, isso: e.target.checked ? 2 : 1, xa: '', huyen: '', duong: '' });
                        // setIsChangeData({ ...isChangeData, 'bán đất': e.target.checked ? 'có' : 'không' });
                        // getStreetsGroup
                      }}
                      color={arrBDS.isso === 2 ? 'green' : ''}
                      className={`${arrBDS.isso === 2 ? 'text-red-500 font-bold' : 'text-black font-bold'}`}
                      checked={arrBDS.isso === 2}
                    />
                  </div>
                </div>
              </div>
              <div className="grid lg:grid-rows-2 lg:grid-flow-col sm:grid-cols-1 gap-4 p-3">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>Số nhà (nếu có)</b>
                    </label>
                    <Input
                      value={arrBDS?.sonha}
                      placeholder="VD: 15A-17/1-3"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      labelProps={{
                        className: 'hidden',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, sonha: e.target.value });
                        setIsChangeData({ ...isChangeData, 'số nhà': e.target.value });
                      }}
                    />
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>Số Lô (KQH)</b>
                    </label>
                    {arrSoLo?.map((row, i) => (
                      <div key={i} className="mb-1 flex">
                        <Input
                          value={row}
                          placeholder="nhập số lô (KQH)"
                          className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                          labelProps={{
                            className: 'hidden',
                          }}
                          onChange={(e) => changeSoLo(e, i)}
                        />

                        {i !== 0 && (
                          <IconButton variant="text">
                            <TrashIcon className="h-5 w-5 text-red-500" onClick={() => removeSoLo(i)} />
                          </IconButton>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Quận, huyện, TP thuộc Tỉnh */}
                <div>
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div>
                      <label className="flex items-end gap-1 text-sm mb-1">
                        <b>
                          Quận, huyện, TP thuộc Tỉnh <b className="text-red-500">*</b>
                        </b>
                      </label>

                      <div className="relative">
                        <button
                          className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                          onClick={() => {
                            handleOpen(1);
                            getStreetsGroup();
                          }}
                        >
                          <span className="mr-2">
                            {arrBDS && arrBDS.huyen ? arrBDS.huyen : 'Chọn Quận, huyện, TP thuộc Tỉnh'}
                          </span>

                          {open === 1 ? <ChevronUpIcon className="h-5 w-5" /> : <ChevronDownIcon className="h-5 w-5" />}
                        </button>
                        {open === 1 && (
                          <div
                            className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                          >
                            <Input
                              // value={}
                              className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                              labelProps={{
                                className: 'hidden',
                              }}
                              onChange={(e) => handleSearchOptionSelect('streets', e.target.value, 'huyen')}
                            />

                            <div className="pl-1">
                              <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                            </div>
                            {arrOptionSelectSearch?.streets &&
                              uniqueData(arrOptionSelectSearch?.streets, 'huyen')?.map((row, index) => (
                                <div
                                  className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                  key={index}
                                  onClick={() => {
                                    setArrBDS({ ...arrBDS, huyen: row?.huyen, duong: '', xa: '' });
                                    handleOpen(0);
                                    handleSearchOptionSelect('streets', row?.huyen, 'huyen');
                                    setIsChangeData({ ...isChangeData, huyện: row?.huyen });
                                  }}
                                >
                                  {row?.huyen},{row?.tinh}
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    </div>
                    {arrBDS?.isso === 1 && (
                      <div>
                        <label className="flex items-end gap-1 text-sm mb-1">
                          <b>
                            Phường, xã (Cũ) <b className="text-red-500">*</b>
                          </b>
                        </label>

                        <div className="relative">
                          <button
                            className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                            onClick={() => {
                              handleOpen(2);
                              if (arrBDS.huyen) {
                                handleSearchOptionSelect('streets', arrBDS.huyen, 'huyen');
                              }
                            }}
                            disabled={arrBDS.huyen ? false : true}
                          >
                            <span className="mr-2">
                              {' '}
                              {arrBDS && arrBDS.xa
                                ? arrBDS.xa +
                                  `${
                                    arrOptionSelect?.streets?.length > 0 &&
                                    arrOptionSelect['streets'].filter((item) => item.xa === arrBDS.xa)[0]?.phuong_group
                                      ? ` (${
                                          arrOptionSelect['streets'].filter((item) => item.xa === arrBDS.xa)[0]
                                            ?.phuong_group
                                        })`
                                      : ''
                                  }`
                                : 'Chọn Phường, xã'}
                            </span>
                            {open === 2 ? (
                              <ChevronUpIcon className="h-5 w-5" />
                            ) : (
                              <ChevronDownIcon className="h-5 w-5" />
                            )}
                          </button>
                          {open === 2 && (
                            <div
                              className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                            >
                              <Input
                                // value={}
                                className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                                labelProps={{
                                  className: 'hidden',
                                }}
                                onChange={(e) => handleSearchOptionSelect('streets', e.target.value, 'xa')}
                              />

                              <div className="pl-1">
                                <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                              </div>
                              {arrOptionSelectSearch?.streets &&
                                uniqueData(arrOptionSelectSearch?.streets, 'xa')?.map((row, index) => (
                                  <div
                                    className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                    key={index}
                                    onClick={() => {
                                      setArrBDS({ ...arrBDS, xa: row?.xa, duong: '' });
                                      handleOpen(0);
                                      handleSearchOptionSelect('streets', row?.xa, 'xa');
                                      setIsChangeData({ ...isChangeData, xã: row?.xa });
                                    }}
                                  >
                                    {row?.xa},{row?.huyen}
                                  </div>
                                ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* PHƯỜNG MỚI */}
                    {arrBDS?.isso === 2 && (
                      <div>
                        <label className="flex items-end gap-1 text-sm mb-1">
                          <b>
                            Phường, xã (Mới) <b className="text-red-500">*</b>
                          </b>
                        </label>

                        <div className="relative">
                          <button
                            className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                            onClick={() => {
                              handleOpen(2);
                              if (arrBDS.huyen) {
                                handleSearchOptionSelect('streets', arrBDS.huyen, 'huyen');
                              }
                            }}
                            disabled={arrBDS.huyen ? false : true}
                          >
                            <span className="mr-2"> {arrBDS && arrBDS.xa ? arrBDS.xa : 'Chọn Phường, xã'}</span>
                            {open === 2 ? (
                              <ChevronUpIcon className="h-5 w-5" />
                            ) : (
                              <ChevronDownIcon className="h-5 w-5" />
                            )}
                          </button>
                          {open === 2 && (
                            <div
                              className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                            >
                              <Input
                                // value={}
                                className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                                labelProps={{
                                  className: 'hidden',
                                }}
                                onChange={(e) => handleSearchOptionSelect('streets', e.target.value, 'phuong_group')}
                              />

                              <div className="pl-1">
                                <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                              </div>
                              {arrOptionSelectSearch?.streets &&
                                uniqueData(arrOptionSelectSearch?.streets, 'phuong_group')?.map((row, index) => (
                                  <div
                                    className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                    key={index}
                                    onClick={() => {
                                      setArrBDS({ ...arrBDS, xa: row?.phuong_group, duong: '' });
                                      handleOpen(0);
                                      handleSearchOptionSelect('streets', row?.phuong_group, 'phuong_group');
                                      setIsChangeData({ ...isChangeData, xã: row?.phuong_group });
                                    }}
                                  >
                                    {row?.phuong_group},{row?.huyen}
                                  </div>
                                ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <label className="flex items-end gap-1 text-sm mb-1">
                    <b>
                      Tên Đường <b className="text-red-500">*</b>
                    </b>
                  </label>

                  <div className="relative">
                    <button
                      className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                      disabled={arrBDS.xa ? false : true}
                      onClick={() => {
                        handleOpen(3);
                      }}
                    >
                      <span className="mr-2">
                        {arrBDS && arrBDS.duong ? arrBDS.duong : 'Nhập tên đường của đúng Quận/Huyện'}
                      </span>
                      {open === 3 ? <ChevronUpIcon className="h-5 w-5" /> : <ChevronDownIcon className="h-5 w-5" />}
                    </button>
                    {open === 3 && (
                      <div
                        className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                      >
                        <Input
                          // value={}
                          placeholder="Nhập tên đường"
                          className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                          labelProps={{
                            className: 'hidden',
                          }}
                          onChange={(e) => handleSearchOptionSelect('streets', e.target.value, 'duong')}
                        />

                        <div className="pl-1">
                          <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                        </div>
                        {arrOptionSelectSearch?.streets &&
                          arrOptionSelectSearch?.streets.map((row, index) => (
                            <div
                              className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                              key={index}
                              onClick={() => {
                                setArrBDS({ ...arrBDS, duong: row?.duong });
                                handleOpen(0);
                                setIsChangeData({ ...isChangeData, đường: row?.duong });
                              }}
                            >
                              {row?.duong},{row?.xa}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <label className="flex items-end gap-1 text-sm mb-1">
                    <b>
                      Số tờ <b className="text-red-500">*</b>
                    </b>
                    <Tooltip content="Nhập đúng số tờ trong sổ" placement="right">
                      <InformationCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                    </Tooltip>
                  </label>

                  {arrSoTo?.map((row, i) => (
                    <div key={i} className="mb-1 flex">
                      {i !== 0 && (
                        <IconButton variant="text">
                          <TrashIcon className="h-5 w-5 text-red-500" onClick={() => removeToThua(i)} />
                        </IconButton>
                      )}
                      <Input
                        value={row}
                        placeholder="vd: 245"
                        className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                        labelProps={{
                          className: 'hidden',
                        }}
                        onChange={(e) => changeSoTo(e, i)}
                      />
                    </div>
                  ))}
                </div>

                <div>
                  <label className="flex items-end gap-1 text-sm mb-1">
                    <b>Khu quy hoạch Đà lạt (nếu có)</b>
                  </label>

                  <div className="relative">
                    <button
                      className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                      onClick={() => {
                        handleOpen(4);
                        getKQH();
                      }}
                    >
                      <span className="mr-2"> {arrBDS && arrBDS.khuqh ? arrBDS.khuqh : 'Chọn KQH nếu có ...'}</span>
                      {open === 4 ? <ChevronUpIcon className="h-5 w-5" /> : <ChevronDownIcon className="h-5 w-5" />}
                    </button>
                    {open === 4 && (
                      <div
                        className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                      >
                        <Input
                          // value={''}

                          className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                          labelProps={{
                            className: 'hidden',
                          }}
                          onChange={(e) => handleSearchOptionSelect('kqhs', e.target.value, 'name')}
                        />

                        <div className="pl-1">
                          <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                        </div>
                        {arrOptionSelectSearch?.kqhs &&
                          arrOptionSelectSearch?.kqhs.map((row, index) => (
                            <div
                              className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                              key={index}
                              onClick={() => {
                                setArrBDS({ ...arrBDS, khuqh: row?.name });
                                handleOpen(0);
                                setIsChangeData({ ...isChangeData, 'khu quy hoạch': row?.name });
                              }}
                            >
                              {row?.name}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <label className="flex items-end gap-1 text-sm mb-1">
                    <b>
                      Số thửa <b className="text-red-500">*</b>
                    </b>
                    <Tooltip content="Nhập đúng số thửa trong sổ" placement="right">
                      <InformationCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                    </Tooltip>
                  </label>

                  {arrSoThua?.map((row, i) => (
                    <div key={i} className="mb-1">
                      <Input
                        value={row}
                        placeholder="vd: 689"
                        className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                        labelProps={{
                          className: 'hidden',
                        }}
                        onChange={(e) => changeSoThua(e, i)}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className="p-2 grid grid-cols-1">
                <div className="flex justify-end gap-2">
                  <Button
                    size="sm"
                    color="green"
                    className="normal-case"
                    onClick={() => {
                      setArrSoLo([...arrSoLo, '']);
                    }}
                  >
                    Thêm Số Lô
                  </Button>
                  <Button
                    size="sm"
                    color="blue"
                    className="normal-case"
                    onClick={() => {
                      setArrSoTo([...arrSoTo, '']);
                      setArrSoThua([...arrSoThua, '']);
                    }}
                  >
                    Thêm Tờ/Thửa
                  </Button>
                </div>
              </div>
            </div>

            {/* SỐ ĐIỆN THOẠI CỦA CHỦ */}
            <div className="grid border border-gray-400 rounded-md">
              <div className="font-bold border-b-2 border-gray-400 p-2">Thông tin chủ</div>
              <div className="grid lg:grid-cols-2 grid-cols-1 gap-2 p-3">
                <div>
                  <label className="flex items-end gap-1 text-sm mb-1">
                    <b>Nhập Số điện thoại kèm theo tên Chủ</b>
                    <Tooltip content="..." placement="right">
                      <QuestionMarkCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                    </Tooltip>

                    <b>
                      | Vai trò (tương ứng thứ tự SĐT ) <b className="text-red-500">*</b>
                    </b>
                    <Tooltip content="..." placement="right">
                      <QuestionMarkCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                    </Tooltip>
                  </label>
                  {arrPhone?.map((row, i) => (
                    <div key={i} className="mb-1 grid grid-cols-2 gap-2">
                      <div>
                        <Input
                          value={row}
                          placeholder="vd: 0912345678 anh A"
                          className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                          labelProps={{
                            className: 'hidden',
                          }}
                          containerProps={{
                            className: 'min-w-[0px!important]',
                          }}
                          onChange={(e) => changePhone(e, i)}
                        />
                      </div>
                      <div className="flex">
                        {/* <Input
                          value={arrPhoneVaiTro[i]}
                          placeholder="Chủ, Họ hàng, Đại diện"
                          className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                          labelProps={{
                            className: 'hidden',
                          }}
                          containerProps={{
                            className: 'min-w-[0px!important]',
                          }}
                          onChange={(e) => changePhoneVaiTro(e, i)}
                        /> */}
                        <Select
                          label="Chọn vai trò"
                          value={arrPhoneVaiTro?.[i] ?? ''}
                          onChange={(value) => changePhoneVaiTro(value, i)}
                          containerProps={{
                            className: 'min-w-[0px!important]',
                          }}
                        >
                          {Array.isArray(listVaiTro) &&
                            listVaiTro.filter(Boolean).map((row, idx) => (
                              <Option key={row.value} value={row.value}>
                                {row.name}
                              </Option>
                            ))}
                        </Select>
                        {i !== 0 && (
                          <IconButton variant="text">
                            <TrashIcon className="h-5 w-5 text-red-500" onClick={() => removePhone(i)} />
                          </IconButton>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="p-2">
                <Button
                  size="sm"
                  color="blue"
                  className="normal-case"
                  onClick={() => {
                    setArrPhone([...arrPhone, '']);
                    setArrPhoneVaiTro([...arrPhoneVaiTro, '']);
                  }}
                >
                  Thêm
                </Button>
              </div>

              <div className="p-2">
                <label>
                  <b>Kiểm tra Đã có thông tin chưa ?</b>
                </label>
              </div>
              {arrResultOld.length > 0 && (
                <div className="p-2 bg-yellow-50">
                  <label>
                    <b className={`${isCheckTrung ? 'text-red-500' : 'text-green-500'}`}>
                      {isCheckTrung
                        ? 'Đã có thông tin BĐS này! Có thể bạn đã nhập chậm trong tíc tắc!'
                        : 'Có thể nhập! Chưa có thông tin Bất Động Sản nhưng SĐT này đồng thời là chủ sở hữu của các Bất Động Sản khác dưới đây:'}
                    </b>
                  </label>
                  <br />
                  {arrResultOld.map((row, i) => (
                    <div key={i}>
                      <hr className="my-2 border-blue-gray-200" />
                      <div className="mb-2">
                        <span className="text-red-500">
                          {/* <b> + {row.sdtchudat} </b> */}
                          {row?.soto?.split(',').length > 1
                            ? row?.soto?.split(',').map((rows, i) => (
                                <span key={i}>
                                  <br />
                                  -Tờ: {rows} - Thửa: {row.sothua.split(',')[i]} - {row.xa},{row.huyen}
                                </span>
                              ))
                            : `${row?.soto ? `-Tờ: ${row?.soto}` : ''} ${
                                row?.sothua ? `- Thửa: ${row?.sothua}` : ''
                              } - ${row.xa},${row.huyen}` || ''}
                        </span>
                      </div>
                      <div className="grid grid-cols-6 gap-2 rounded-[40px] border-t-2 border-t-amber-500 p-2 hover:bg-[#fffdf4]">
                        <div>
                          <LazyLoadImage
                            alt={'không có ảnh'}
                            width={'50%'}
                            effect="blur"
                            src={row?.avt}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = images.banner_login;
                            }}
                            className="rounded-3xl w-72"
                          />
                        </div>

                        <div className="col-span-5">
                          {isCheckWifi ? (
                            <Link to={`/bds/${encode(row.id)}`} target="_blank">
                              <h2 className="text-base font-bold mb-1 cursor-pointer  ">
                                {`>>>Đã có>>> `}
                                <span className="text-blue-500 underline">
                                  {`${row.loaibds ? row?.loaibds : ''}${row.loaivitri ? ' - ' + row?.loaivitri : ''}${
                                    row.phaply ? ' - ' + row?.phaply : ''
                                  }${row.duong ? ' - đường ' + row?.duong + ', ' + row?.xa + ', ' + row?.huyen : ''}${
                                    row.rongduong ? ', R' + row?.rongduong + 'm' : ''
                                  }`}
                                </span>
                              </h2>
                            </Link>
                          ) : (
                            <h2 className="text-base font-bold mb-1 cursor-pointer  ">
                              {`>>>Đã có>>> `}
                              <span className="text-blue-500 underline">
                                {`${row.loaibds ? row?.loaibds : ''}${row.loaivitri ? ' - ' + row?.loaivitri : ''}${
                                  row.phaply ? ' - ' + row?.phaply : ''
                                }${row.duong ? ' - đường ' + row?.duong + ', ' + row?.xa + ', ' + row?.huyen : ''}${
                                  row.rongduong ? ', R' + row?.rongduong + 'm' : ''
                                }`}
                              </span>
                            </h2>
                          )}

                          <div>
                            <span>
                              {row.username} - nhập vào: {row.create_date} - cập nhật: {row.update_date}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div>
                        {messagePhoneNew !== 'Thành Công' && (
                          <div>
                            {isCheckTrung && (
                              <div>
                                <hr className="my-2 border-blue-gray-200" />
                                {isCheckWifi && (
                                  <span className="text-blue-500 font-bold">
                                    Nhấn vào link để xem và bổ sung SĐT chủ mới hoặc nhập trực tiếp vào ô dưới đây
                                  </span>
                                )}
                                <br />
                                <span className="text-green-500 font-bold"> BẠN CÓ MUỐN CẬP NHẬT THÊM SĐT MỚI?</span>
                                <div className="grid grid-cols-1 gap-2 lg:grid-cols-4">
                                  <Input
                                    value={phoneNewChu[i]}
                                    placeholder="vd: 0912345678 anh A"
                                    className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                                    labelProps={{
                                      className: 'hidden',
                                    }}
                                    onChange={(e) => handleChangePhoneChu(i, e)}
                                  />
                                  <Select
                                    label="Chọn vai trò"
                                    value={arrPhoneVaiTro?.[i] ?? ''}
                                    onChange={(value) => changePhoneVaiTro(value, i)}
                                    containerProps={{
                                      className: 'min-w-[0px!important]',
                                    }}
                                  >
                                    {Array.isArray(listVaiTro) &&
                                      listVaiTro.filter(Boolean).map((row, idx) => (
                                        <Option key={row.value} value={row.value}>
                                          {row.name}
                                        </Option>
                                      ))}
                                  </Select>
                                  <Button
                                    color="green"
                                    onClick={() => {
                                      subUpdateSDTNEW2(row, i);
                                    }}
                                  >
                                    Lưu Lại
                                  </Button>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {/* {messagePhoneNew && (
                          <span
                            className={`${
                              messagePhoneNew === 'Thành Công' ? 'text-green-500' : 'text-red-500'
                            } font-bold`}
                          >
                            {messagePhoneNew === 'Thành Công' ? 'CẬP NHẬT THÀNH CÔNG' : messagePhoneNew}
                          </span>
                        )} */}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="p-2">
                <Button
                  size="sm"
                  color="red"
                  className="normal-case"
                  onClick={() => {
                    handleCheckPhoneChu();
                  }}
                >
                  Kiểm Tra Trùng
                </Button>
                <br />
                {resultBVID.length === 0 && arrResultOld.length === 0 && (
                  <span className="text-red-500 font-bold">
                    {' '}
                    Nhấn Kiểm tra trùng trước khi thực hiện bước tiếp theo.
                  </span>
                )}

                <br />
                {warningMessagePhone && arrResultOld.length === 0 && (
                  <b
                    className={
                      warningMessagePhone ===
                      'Có thể nhập ! Chưa có thông tin BĐS cùng SĐT chủ này ! (dựa trên Số Tờ/Thửa, Phường/xã & SĐT)'
                        ? 'text-green-500'
                        : 'text-red-500'
                    }
                  >
                    {warningMessagePhone}
                  </b>
                )}
                <br />
                {resultBVID.length > 0 && isCheckWifi && arrResultOld.length === 0 && (
                  <Link to={`/bds/${encode(resultBVID[0].id)}`} target="_blank" className="font-bold ">
                    <h2 className="text-base font-bold mb-1 cursor-pointer  ">
                      {`>>>Đã có>>> `}
                      <span className="text-blue-500 underline">
                        {`${resultBVID[0].loaibds ? resultBVID[0]?.loaibds : ''}${
                          resultBVID[0].loaivitri ? ' - ' + resultBVID[0]?.loaivitri : ''
                        }${resultBVID[0].phaply ? ' - ' + resultBVID[0]?.phaply : ''}${
                          resultBVID[0].duong
                            ? ' - đường ' +
                              resultBVID[0]?.duong +
                              ', ' +
                              resultBVID[0]?.xa +
                              ', ' +
                              resultBVID[0]?.huyen
                            : ''
                        }${resultBVID[0].rongduong ? ', R' + resultBVID[0]?.rongduong + 'm' : ''}`}
                      </span>
                      <br />
                      <span>{'>>> (Ấn vào Link nếu bạn muốn CẬP NHẬT SĐT MỚI)'}</span>
                    </h2>
                  </Link>
                )}

                {resultBVID.length > 0 &&
                  !isCheckWifi &&
                  messagePhoneNew !== 'Thành Công' &&
                  arrResultOld.length === 0 && (
                    <div>
                      <h2 className="text-base font-bold mb-1 cursor-pointer  ">
                        {`>>>Đã có>>> `}
                        <span className="text-blue-500 underline">
                          {`${resultBVID[0].loaibds ? resultBVID[0]?.loaibds : ''}${
                            resultBVID[0].loaivitri ? ' - ' + resultBVID[0]?.loaivitri : ''
                          }${resultBVID[0].phaply ? ' - ' + resultBVID[0]?.phaply : ''}${
                            resultBVID[0].duong
                              ? ' - đường ' +
                                resultBVID[0]?.duong +
                                ', ' +
                                resultBVID[0]?.xa +
                                ', ' +
                                resultBVID[0]?.huyen
                              : ''
                          }${resultBVID[0].rongduong ? ', R' + resultBVID[0]?.rongduong + 'm' : ''}`}
                        </span>
                      </h2>
                      <br />
                      <span className="text-green-500 font-bold"> BẠN CÓ MUỐN CẬP NHẬT THÊM SĐT MỚI?</span>
                      <div className="grid grid-cols-1 gap-2 lg:grid-cols-4">
                        <Input
                          value={phoneNewChu[0]}
                          placeholder="vd: 0912345678 anh A"
                          className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                          labelProps={{
                            className: 'hidden',
                          }}
                          onChange={(e) => handleChangePhoneChu(0, e)}
                        />
                        <Select
                          label="Chọn vai trò"
                          value={arrPhoneVaiTro?.[0] ?? ''}
                          onChange={(value) => changePhoneVaiTro(value, 0)}
                          containerProps={{
                            className: 'min-w-[0px!important]',
                          }}
                        >
                          {Array.isArray(listVaiTro) &&
                            listVaiTro.filter(Boolean).map((row, idx) => (
                              <Option key={row.value} value={row.value}>
                                {row.name}
                              </Option>
                            ))}
                        </Select>
                        <Button color="green" onClick={subUpdateSDTNEW}>
                          Lưu Lại
                        </Button>
                      </div>
                    </div>
                  )}
                {messagePhoneNew && (
                  <span className={`${messagePhoneNew === 'Thành Công' ? 'text-green-500' : 'text-red-500'} font-bold`}>
                    {messagePhoneNew === 'Thành Công' ? 'CẬP NHẬT THÀNH CÔNG' : messagePhoneNew}
                  </span>
                )}
              </div>
            </div>

            {/* CHI TIẾT BẤT ĐỘNG SẢN */}
            <div className="grid border border-gray-400 rounded-md">
              <div className="font-bold border-b-2 border-gray-400 p-2">Chi tiết BĐS</div>
              <div className="grid grid-cols-1 p-3">
                <div>
                  <label className="flex items-end gap-1 text-sm mb-1">
                    <b>
                      Bán - Cho Thuê? <b className="text-red-500">*</b>
                    </b>
                  </label>
                </div>
                <div className="grid grid-rows-2">
                  <div>
                    <Checkbox
                      label="Bán"
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, isbandat: e.target.checked ? 1 : 0 });
                        setIsChangeData({ ...isChangeData, 'bán đất': e.target.checked ? 'có' : 'không' });
                      }}
                      checked={arrBDS.isbandat > 0}
                    />
                    {arrBDS.isbandat > 0 && (
                      <div className="grid grid-rows-1 lg:grid-cols-3">
                        <div>
                          <label className="flex items-end gap-1 text-sm mb-1">
                            <b>
                              {' '}
                              Giá bán (số tiền) <b className="text-red-500">*</b>{' '}
                            </b>
                            <Tooltip content="..." placement="right">
                              <InformationCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                            </Tooltip>
                          </label>

                          <Input
                            value={arrBDS?.gia}
                            type="number"
                            className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            icon={<b className="border-l-2 p-[5px] mt-[-7px] ml-[-10px]">vnđ</b>} //㎡
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => {
                              setArrBDS({ ...arrBDS, gia: e.target.value });
                              setIsChangeData({ ...isChangeData, 'giá bán': e.target.value });
                            }}
                          />
                          <b className="text-red-600 text-sm">{convertNumberToWords(arrBDS?.gia * 1000000000)}</b>
                        </div>
                      </div>
                    )}
                  </div>

                  <div>
                    <Checkbox
                      label="Cho thuê"
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, ischothue: e.target.checked ? 1 : 0 });
                        setIsChangeData({ ...isChangeData, 'cho thuê': e.target.checked ? 'có' : 'không' });
                      }}
                      checked={arrBDS.ischothue > 0}
                    />
                    {arrBDS.ischothue > 0 && (
                      <div className="grid grid-rows-1 lg:grid-cols-3">
                        <div>
                          <label className="flex items-end gap-1 text-sm mb-1">
                            <b>
                              {' '}
                              Thu nhập từ cho thuê (số tiền) <b className="text-red-500">*</b>{' '}
                            </b>
                            <Tooltip content="..." placement="right">
                              <InformationCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                            </Tooltip>
                          </label>

                          <Input
                            value={arrBDS?.giathue}
                            type="number"
                            className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            icon={<b className="border-l-2 p-[5px] mt-[-7px] ml-[-10px]">vnđ</b>} //㎡
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => {
                              setArrBDS({ ...arrBDS, giathue: e.target.value });
                              setIsChangeData({ ...isChangeData, 'giá thuê': e.target.value });
                            }}
                          />
                          <b className="text-red-600 text-sm">{convertNumberToWords(arrBDS?.giathue)}</b>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>
                        Rộng đường trước nhà <b className="text-red-500">*</b>
                      </b>
                    </label>

                    <Input
                      value={arrBDS?.rongduong}
                      type="number"
                      placeholder="vd: 6,8m nhập 6.8"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      icon={<b className="border-l-2 p-[5px] mt-[-7px] ">m</b>} //㎡
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{
                        className: 'min-w-[0px!important]',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, rongduong: e.target.value });
                        setIsChangeData({ ...isChangeData, 'đường rộng': e.target.value });
                      }}
                    />
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>
                        Quy Hoạch <b className="text-red-500">*</b>
                      </b>
                    </label>
                    <div className="relative">
                      <button
                        className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                        onClick={() => {
                          handleOpen(5);
                          getQH();
                        }}
                      >
                        <span className="mr-2"> {arrBDS && arrBDS.quyhoach ? arrBDS.quyhoach : 'Chọn Quy Hoạch'}</span>
                        {open === 5 ? <ChevronUpIcon className="h-5 w-5" /> : <ChevronDownIcon className="h-5 w-5" />}
                      </button>
                      {open === 5 && (
                        <div
                          className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                        >
                          <Input
                            // value={''}

                            className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => handleSearchOptionSelect('qhs', e.target.value, 'name')}
                          />

                          <div className="pl-1">
                            <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                          </div>
                          {arrOptionSelectSearch?.qhs &&
                            arrOptionSelectSearch?.qhs.map((row, index) => (
                              <div
                                className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                key={index}
                                onClick={() => {
                                  setArrBDS({ ...arrBDS, quyhoach: row?.name });
                                  handleOpen(0);
                                  setIsChangeData({ ...isChangeData, 'quy hoạch': row?.name });
                                }}
                              >
                                {row?.name}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>Pháp lý</b>
                    </label>

                    <div className="relative">
                      <button
                        className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                        onClick={() => {
                          handleOpen(6);
                          getPhaply();
                        }}
                      >
                        <span className="mr-2"> {arrBDS && arrBDS.phaply ? arrBDS.phaply : 'Chọn Pháp Lý'}</span>
                        {open === 6 ? <ChevronUpIcon className="h-5 w-5" /> : <ChevronDownIcon className="h-5 w-5" />}
                      </button>
                      {open === 6 && (
                        <div
                          className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                        >
                          <Input
                            // value={''}

                            className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => handleSearchOptionSelect('phaply', e.target.value, 'name')}
                          />

                          <div className="pl-1">
                            <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                          </div>
                          {arrOptionSelectSearch?.phaply &&
                            arrOptionSelectSearch?.phaply.map((row, index) => (
                              <div
                                className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                key={index}
                                onClick={() => {
                                  setArrBDS({ ...arrBDS, phaply: row?.name });
                                  handleOpen(0);
                                  setIsChangeData({ ...isChangeData, 'pháp lý': row?.name });
                                }}
                              >
                                {row?.name}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="lg:col-span-2">
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>
                        Hướng BĐS <b className="text-red-500">*</b>
                      </b>
                    </label>

                    <div className="relative">
                      <button
                        className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                        onClick={() => {
                          handleOpen(7);
                          getHuongBds();
                        }}
                      >
                        {arrBDS && arrBDS.huongbds ? (
                          <span className="mr-2 grid grid-cols-3 gap-2">
                            {arrBDS.huongbds?.split(',')?.map((row, i) => (
                              <Chip
                                value={row}
                                variant="ghost"
                                icon={<XCircleIcon />}
                                key={i}
                                onClick={() => removeDataBds(arrBDS.huongbds?.split(','), 'huongbds', i)}
                              />
                            ))}
                          </span>
                        ) : (
                          <span className="mr-2">Chọn Hướng, Có thể chọn nhiều hướng...</span>
                        )}
                        {open === 7 ? <ChevronUpIcon className="h-5 w-5" /> : <ChevronDownIcon className="h-5 w-5" />}
                      </button>

                      {open === 7 && (
                        <div
                          className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                        >
                          <Input
                            className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => handleSearchOptionSelect('huongbds', e.target.value, 'name')}
                          />

                          <div className="pl-1">
                            <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                          </div>

                          {arrOptionSelectSearch?.huongbds &&
                            arrOptionSelectSearch?.huongbds.map((row, index) => (
                              <div
                                className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                key={index}
                                onClick={() => {
                                  // --- helper: chuyển về Title Case (chữ đầu mỗi từ viết hoa)
                                  const toTitleCase = (str = '') =>
                                    str
                                      .toLowerCase()
                                      .split(' ')
                                      .filter(Boolean)
                                      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                                      .join(' ');

                                  const rawName = (row?.name || '').trim();
                                  if (!rawName) return;

                                  // chuẩn hoá để so sánh
                                  const selectedUpper = rawName.toUpperCase();

                                  // nhóm hướng
                                  const TAY_GROUP = ['TÂY', 'TÂY NAM', 'TÂY BẮC', 'ĐÔNG BẮC'];
                                  const DONG_GROUP = ['ĐÔNG', 'BẮC', 'ĐÔNG NAM', 'NAM'];

                                  // quyết định thêm Tứ Trạch
                                  let extraUpper = '';
                                  if (TAY_GROUP.includes(selectedUpper)) extraUpper = 'TÂY TỨ TRẠCH';
                                  else if (DONG_GROUP.includes(selectedUpper)) extraUpper = 'ĐÔNG TỨ TRẠCH';

                                  // lấy danh sách hiện tại, chuẩn hoá và loại rỗng
                                  const currentListRaw = (arrBDS?.huongbds || '')
                                    .split(',')
                                    .map((s) => s.trim())
                                    .filter(Boolean);

                                  // set để so sánh theo uppercase
                                  const currentSetUpper = new Set(currentListRaw.map((s) => s.toUpperCase()));

                                  // nếu đã có hướng chính (theo uppercase)
                                  if (currentSetUpper.has(selectedUpper)) {
                                    // nếu đã có rồi nhưng thiếu extra thì thêm extra
                                    if (extraUpper && !currentSetUpper.has(extraUpper)) {
                                      currentSetUpper.add(extraUpper);
                                    } else {
                                      // không cần thay đổi
                                      handleOpen(0);
                                      return;
                                    }
                                  } else {
                                    // thêm hướng chính và extra (nếu có)
                                    currentSetUpper.add(selectedUpper);
                                    if (extraUpper) currentSetUpper.add(extraUpper);
                                  }

                                  // tạo danh sách cuối cùng từ set (giữ thứ tự: giữ các phần hiện có ban đầu, sau đó thêm phần mới)
                                  // Đầu tiên lấy các phần hiện có (original casing) nhưng lọc bỏ những phần đã bị xóa/chuẩn hoá
                                  const finalListOrdered = [];

                                  // push existing items (preserve original casing) nếu vẫn nằm trong set
                                  for (const item of currentListRaw) {
                                    if (currentSetUpper.has(item.toUpperCase())) {
                                      finalListOrdered.push(item);
                                      currentSetUpper.delete(item.toUpperCase()); // đã thêm, remove để tránh duplicate
                                    }
                                  }

                                  // thêm phần còn lại (mới) từ set theo Title Case
                                  const remaining = Array.from(currentSetUpper);
                                  remaining.forEach((u) => {
                                    finalListOrdered.push(toTitleCase(u.toLowerCase()));
                                  });

                                  // lưu chuỗi (Title Case, ví dụ "Tây, Tây Nam")
                                  const finalHuongStr = finalListOrdered.join(',');

                                  setArrBDS({
                                    ...arrBDS,
                                    huongbds: finalHuongStr,
                                  });

                                  setIsChangeData({
                                    ...isChangeData,
                                    'hướng bđs': finalHuongStr,
                                  });

                                  handleOpen(0);
                                }}
                              >
                                <b className={`${checkText(arrBDS.huongbds, row?.name) ? 'text-gray-500' : ''}`}>
                                  {row?.name}
                                </b>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <hr className="my-6 border-blue-gray-100" />

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>
                        Loại Vị trí (MT, Hẻm...)<b className="text-red-500">*</b>
                      </b>
                    </label>

                    <div className="relative">
                      <button
                        className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                        onClick={() => {
                          handleOpen(8);
                          getLoaiVitri();
                        }}
                      >
                        {' '}
                        {arrBDS && arrBDS.loaivitri ? (
                          <span className="mr-2 grid grid-cols-2 gap-2">
                            {arrBDS.loaivitri?.split(',')?.map((row, i) => (
                              <Chip
                                value={row}
                                variant="ghost"
                                icon={<XCircleIcon />}
                                key={i}
                                onClick={() => removeDataBds(arrBDS.loaivitri?.split(','), 'loaivitri', i)}
                              />
                            ))}
                          </span>
                        ) : (
                          <span className="mr-2">Nhấn, Có thể chọn nhiều...</span>
                        )}
                      </button>
                      {open === 8 && (
                        <div
                          className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                        >
                          <Input
                            // value={''}

                            className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => handleSearchOptionSelect('loaivitri', e.target.value, 'name')}
                          />

                          <div className="pl-1">
                            <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                          </div>
                          {arrOptionSelectSearch?.loaivitri &&
                            arrOptionSelectSearch?.loaivitri.map((row, index) => (
                              <div
                                className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                key={index}
                                onClick={() => {
                                  if (!checkText(arrBDS.loaivitri, row?.name)) {
                                    setArrBDS({
                                      ...arrBDS,
                                      loaivitri: `${arrBDS['loaivitri'] ? arrBDS['loaivitri'] + ',' : ''}${row?.name}`,
                                    });
                                    setIsChangeData({
                                      ...isChangeData,
                                      'loại vị trí': `${arrBDS['loaivitri'] ? arrBDS['loaivitri'] + ',' : ''}${
                                        row?.name
                                      }`,
                                    });
                                    handleOpen(0);
                                  }
                                }}
                              >
                                <b className={`${checkText(arrBDS.loaivitri, row?.name) ? 'text-gray-500' : ''}`}>
                                  {row?.name}
                                </b>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>
                        Loại BĐS<b className="text-red-500">*</b>
                      </b>
                    </label>

                    <div className="relative">
                      <button
                        className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                        onClick={() => {
                          handleOpen(9);
                          getLoaiBDS();
                        }}
                      >
                        {' '}
                        {arrBDS && arrBDS.loaibds ? (
                          <span className="mr-2 grid grid-cols-2 gap-2">
                            {arrBDS.loaibds?.split(',')?.map((row, i) => (
                              <Chip
                                value={row}
                                variant="ghost"
                                icon={<XCircleIcon />}
                                key={i}
                                onClick={() => removeDataBds(arrBDS.loaibds?.split(','), 'loaibds', i)}
                              />
                            ))}
                          </span>
                        ) : (
                          <span className="mr-2">Nhấn, Có thể chọn nhiều...</span>
                        )}
                      </button>
                      {open === 9 && (
                        <div
                          className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                        >
                          <Input
                            // value={''}

                            className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => handleSearchOptionSelect('loaibds', e.target.value, 'name')}
                          />

                          <div className="pl-1">
                            <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                          </div>
                          {arrOptionSelectSearch?.loaibds &&
                            arrOptionSelectSearch?.loaibds.map((row, index) => (
                              <div
                                className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                key={index}
                                onClick={() => {
                                  if (!checkText(arrBDS.loaibds, row?.name)) {
                                    setArrBDS({
                                      ...arrBDS,
                                      loaibds: `${arrBDS['loaibds'] ? arrBDS['loaibds'] + ',' : ''}${row?.name}`,
                                    });
                                    setIsChangeData({
                                      ...isChangeData,
                                      'loại bđs': `${arrBDS['loaibds'] ? arrBDS['loaibds'] + ',' : ''}${row?.name}`,
                                    });
                                    handleOpen(0);
                                  }
                                }}
                              >
                                <b className={`${checkText(arrBDS.loaibds, row?.name) ? 'text-gray-500' : ''}`}>
                                  {row?.name}
                                </b>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b> Tiện Nghi & Kết Cấu </b>
                      <Tooltip content="..." placement="right">
                        <QuestionMarkCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                      </Tooltip>
                    </label>

                    <div className="relative">
                      <button
                        className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                        onClick={() => {
                          handleOpen(10);
                          getTiennghi();
                        }}
                      >
                        {' '}
                        {arrBDS && arrBDS.tiennghi ? (
                          <span className="mr-2 grid grid-cols-2 gap-2">
                            {arrBDS.tiennghi?.split(',')?.map((row, i) => (
                              <Chip
                                value={row}
                                variant="ghost"
                                icon={<XCircleIcon />}
                                key={i}
                                onClick={() => removeDataBds(arrBDS.tiennghi?.split(','), 'tiennghi', i)}
                              />
                            ))}
                          </span>
                        ) : (
                          <span className="mr-2">SThượng,hầm,hồ bơi....</span>
                        )}
                      </button>
                      {open === 10 && (
                        <div
                          className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                        >
                          <Input
                            // value={''}

                            className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => handleSearchOptionSelect('tiennghi', e.target.value, 'name')}
                          />

                          <div className="pl-1">
                            <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                          </div>
                          {arrOptionSelectSearch?.tiennghi &&
                            arrOptionSelectSearch?.tiennghi.map((row, index) => (
                              <div
                                className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                key={index}
                                onClick={() => {
                                  if (!checkText(arrBDS.tiennghi, row?.name)) {
                                    setArrBDS({
                                      ...arrBDS,
                                      tiennghi: `${arrBDS['tiennghi'] ? arrBDS['tiennghi'] + ',' : ''}${row?.name}`,
                                    });
                                    setIsChangeData({
                                      ...isChangeData,
                                      'tiện nghi': `${arrBDS['tiennghi'] ? arrBDS['tiennghi'] + ',' : ''}${row?.name}`,
                                    });
                                    handleOpen(0);
                                  }
                                }}
                              >
                                <b className={`${checkText(arrBDS.tiennghi, row?.name) ? 'text-gray-500' : ''}`}>
                                  {row?.name}
                                </b>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b> Đặc trưng </b>
                      <Tooltip content="..." placement="right">
                        <QuestionMarkCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                      </Tooltip>
                    </label>

                    <div className="relative">
                      <button
                        className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                        onClick={() => {
                          handleOpen(11);
                          getDactrung();
                        }}
                      >
                        {' '}
                        {arrBDS && arrBDS.dactrung ? (
                          <span className="mr-2 grid grid-cols-2 gap-2">
                            {arrBDS.dactrung?.split(',')?.map((row, i) => (
                              <Chip
                                value={row}
                                variant="ghost"
                                icon={<XCircleIcon />}
                                key={i}
                                onClick={() => removeDataBds(arrBDS.dactrung?.split(','), 'dactrung', i)}
                              />
                            ))}
                          </span>
                        ) : (
                          <span className="mr-2">Nhấn, Có thể chọn nhiều...</span>
                        )}
                      </button>
                      {open === 11 && (
                        <div
                          className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                        >
                          <Input
                            // value={''}

                            className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => handleSearchOptionSelect('dactrung', e.target.value, 'name')}
                          />

                          <div className="pl-1">
                            <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                          </div>
                          {arrOptionSelectSearch?.dactrung &&
                            arrOptionSelectSearch?.dactrung.map((row, index) => (
                              <div
                                className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                key={index}
                                onClick={() => {
                                  if (!checkText(arrBDS.dactrung, row?.name)) {
                                    setArrBDS({
                                      ...arrBDS,
                                      dactrung: `${arrBDS['dactrung'] ? arrBDS['dactrung'] + ',' : ''}${row?.name}`,
                                    });
                                    setIsChangeData({
                                      ...isChangeData,
                                      'đặc trưng': `${arrBDS['dactrung'] ? arrBDS['dactrung'] + ',' : ''}${row?.name}`,
                                    });
                                    handleOpen(0);
                                  }
                                }}
                              >
                                <b className={`${checkText(arrBDS.dactrung, row?.name) ? 'text-gray-500' : ''}`}>
                                  {row?.name}
                                </b>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <hr className="my-6 border-blue-gray-100" />

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>Thông tin thêm (khách có thể đọc được)</b>
                    </label>

                    <Textarea
                      value={arrBDS?.notekhach}
                      type="text"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      labelProps={{
                        className: 'hidden',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, notekhach: e.target.value });
                        setIsChangeData({ ...isChangeData, 'ghi chú khách': e.target.value });
                      }}
                    />
                  </div>
                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>Thông tin nội bộ (chỉ KEYLAND đọc được) - Không Nhập SĐT bên chủ nhà ở đây</b>
                    </label>

                    <Textarea
                      value={arrBDS?.notenoibo}
                      type="text"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      labelProps={{
                        className: 'hidden',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, notenoibo: e.target.value });
                        setIsChangeData({ ...isChangeData, 'ghi chú nội bộ': e.target.value });
                      }}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-6 gap-4  mt-4">
                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>
                        Diện tích đất ở <b className="text-red-500">*</b>
                      </b>
                    </label>

                    <Input
                      value={arrBDS?.dientich}
                      type="number"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      icon={<b className="border-l-2 p-[5px] mt-[-7px] ">㎡</b>} //㎡
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{
                        className: 'min-w-[0px!important]',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, dientich: e.target.value });
                        setIsChangeData({ ...isChangeData, 'diện tích': e.target.value });
                      }}
                    />
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>
                        DT Đất nông nghiệp <b className="text-red-500">*</b>
                      </b>
                    </label>

                    <Input
                      value={arrBDS?.dientichdatnn}
                      type="number"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      icon={<b className="border-l-2 p-[5px] mt-[-7px] ">㎡</b>} //㎡
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{
                        className: 'min-w-[0px!important]',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, dientichdatnn: e.target.value });
                        setIsChangeData({ ...isChangeData, 'dt nông nghiệp': e.target.value });
                      }}
                    />
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>
                        {' '}
                        Ngang <b className="text-red-500">*</b>{' '}
                      </b>
                      <Tooltip content="..." placement="right">
                        <InformationCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                      </Tooltip>
                    </label>

                    <Input
                      value={arrBDS?.ngang}
                      type="number"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      icon={<b className="border-l-2 p-[5px] mt-[-7px] ">m</b>} //㎡
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{
                        className: 'min-w-[0px!important]',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, ngang: e.target.value });
                        setIsChangeData({ ...isChangeData, ngang: e.target.value });
                      }}
                    />
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b> Dài</b>
                      <Tooltip content="..." placement="right">
                        <InformationCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                      </Tooltip>
                    </label>

                    <Input
                      value={arrBDS?.dai}
                      type="number"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      icon={<b className="border-l-2 p-[5px] mt-[-7px] ">m</b>} //㎡
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{
                        className: 'min-w-[0px!important]',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, dai: e.target.value });
                        setIsChangeData({ ...isChangeData, dai: e.target.value });
                      }}
                    />
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>
                        {' '}
                        Số tầng <b className="text-red-500">*</b>{' '}
                      </b>
                      <Tooltip content="..." placement="right">
                        <InformationCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                      </Tooltip>
                    </label>

                    <Input
                      value={arrBDS?.sotang}
                      type="number"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      icon={<b className="border-l-2 p-[5px] mt-[-7px] ml-[-17px]">tầng</b>} //㎡
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{
                        className: 'min-w-[0px!important]',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, sotang: e.target.value });
                        setIsChangeData({ ...isChangeData, 'số tầng': e.target.value });
                      }}
                    />
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>
                        {' '}
                        Số phòng <b className="text-red-500">*</b>{' '}
                      </b>
                    </label>

                    <Input
                      value={arrBDS?.sophong}
                      type="number"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      icon={<b className="border-l-2 p-[5px] mt-[-7px] ml-[-33px] ">phòng</b>} //㎡
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{
                        className: 'min-w-[0px!important]',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, sophong: e.target.value });
                        setIsChangeData({ ...isChangeData, 'số phòng': e.target.value });
                      }}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-4  mt-4">
                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>Số WC</b>
                    </label>

                    <Input
                      value={arrBDS?.sowc}
                      type="number"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      icon={<b className="border-l-2 p-[5px] mt-[-7px] ml-[-10px]">WC</b>} //㎡
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{
                        className: 'min-w-[0px!important]',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, sowc: e.target.value });
                        setIsChangeData({ ...isChangeData, 'số wc': e.target.value });
                      }}
                    />
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b>Tổng DT sàn (các tầng)</b>
                    </label>

                    <Input
                      value={arrBDS?.dientichsan}
                      type="number"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      icon={<b className="border-l-2 p-[5px] mt-[-7px] ">㎡</b>} //㎡
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{
                        className: 'min-w-[0px!important]',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, dientichsan: e.target.value });
                        setIsChangeData({ ...isChangeData, 'diện tích sàn': e.target.value });
                      }}
                    />
                  </div>

                  <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b> Ngang hậu</b>
                      <Tooltip content="..." placement="right">
                        <InformationCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                      </Tooltip>
                    </label>

                    <Input
                      value={arrBDS?.nganghau}
                      type="number"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      icon={<b className="border-l-2 p-[5px] mt-[-7px] ">m</b>} //㎡
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{
                        className: 'min-w-[0px!important]',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, nganghau: e.target.value });
                        setIsChangeData({ ...isChangeData, 'ngang hậu': e.target.value });
                      }}
                    />
                  </div>

                  {/* <div>
                    <label className="flex items-end gap-1 text-sm mb-1">
                      <b> Thu nhập từ cho thuê (số tiền)</b>
                      <Tooltip content="..." placement="right">
                        <InformationCircleIcon className="h-4 w-4 text-gray-500 cursor-pointer" />
                      </Tooltip>
                    </label>

                    <Input
                      value={arrBDS?.giathue}
                      type="number"
                      className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                      icon={<b className="border-l-2 p-[5px] mt-[-7px] ml-[-15px]">vnđ</b>} //㎡
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{
                        className: 'min-w-[0px!important]',
                      }}
                      onChange={(e) => {
                        setArrBDS({ ...arrBDS, giathue: e.target.value });
                        setIsChangeData({ ...isChangeData, 'giá thuê': e.target.value });
                      }}
                    />
                    <b className="text-red-600 text-sm">{convertNumberToWords(arrBDS?.giathue)}</b>
                  </div> */}
                </div>
              </div>
            </div>

            {/* HÌNH ẢNH */}
            <div className="grid border border-gray-400 rounded-md">
              <div className="font-bold border-b-2 border-gray-400 p-2">
                Hình ảnh về BĐS (Tổng tối đa 25 tập tin hình + sổ)
              </div>
              <div className="grid lg:grid-cols-3 grid-cols-1 gap-2 p-3">
                <div>
                  <h3>
                    <b>Hinh ảnh BĐS</b>
                  </h3>
                  <h3 className="mt-4">
                    <b>* tối đa 20 hình</b>
                  </h3>
                  <div className="text-gray-500 text-sm">
                    <p>CHỈ HÌNH NHÀ, KHÔNG SỔ.</p>
                    <p>Hình đầu tiên (rìa trái) sẽ là hình đại diện BĐS</p>
                    <p>Kéo thả ảnh đổi vị trí ảnh đại diện</p>
                  </div>
                </div>

                <div className="col-span-2">
                  {imageURLS.length <= 20 && (
                    <Button onClick={onButtonClickFileImage}>CHỌN HÌNH ẢNH (KHÔNG VIDEO)</Button>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    name="image"
                    id="file"
                    ref={inputFile}
                    style={{ display: 'none' }}
                    onChange={onFilechange}
                  />{' '}
                  <div className="mt-1">Hiển thị ảnh ở đây</div>
                  <div className="grid grid-cols-3 lg:grid-cols-6 gap-4">
                    {checkInfo &&
                      imageURLSAll.length > 0 &&
                      imageURLSAll?.map((imageSrc, i) => (
                        <figure
                          className="relative w-full border border-amber-500 border-dashed p-1 cursor-grab"
                          key={i}
                          draggable
                          onDragStart={() => handleDragStart(i)}
                          onDragEnter={() => handleDragEnterUpdate(i)}
                          onDragEnd={handleDragEnd}
                          onDragOver={(e) => e.preventDefault()}
                        >
                          <img
                            src={
                              typeof imageSrc === 'string'
                                ? imageSrc.startsWith('blob:')
                                  ? imageSrc
                                  : imageSrc
                                : imageSrc.base64
                            }
                            alt="not fount"
                            width={'100%'}
                          />
                          <figcaption className="absolute bottom-4 left-2/4 flex px-1 -translate-x-2/4 justify-center rounded-xl border border-white bg-red-900 text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm">
                            <div>
                              <span onClick={() => removeImageUpdateAll(i)} className="cursor-pointer">
                                xóa
                              </span>
                            </div>
                          </figcaption>
                        </figure>
                      ))}
                    {!checkInfo &&
                      imageURLS.length > 0 &&
                      imageURLS?.map((imageSrc, i) => (
                        <figure
                          className={`relative w-full border border-amber-500 border-dashed p-1 cursor-grab`}
                          key={i}
                          draggable
                          onDragStart={() => handleDragStart(i)}
                          onDragEnter={() => handleDragEnter(i)}
                          onDragEnd={handleDragEnd}
                          onDragOver={(e) => e.preventDefault()}
                        >
                          <img src={imageSrc} alt="not fount" width={'100%'} />
                          <figcaption className="absolute bottom-4 left-2/4 flex px-1 -translate-x-2/4 justify-center rounded-xl border border-white bg-red-900 text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm">
                            <div>
                              <span onClick={() => removeImage(i)} className="cursor-pointer">
                                xóa
                              </span>
                            </div>
                          </figcaption>
                        </figure>
                      ))}
                  </div>
                </div>
              </div>

              <hr className="my-6 border-blue-gray-100" />

              <div className="grid lg:grid-cols-3 grid-cols-1 gap-2 p-3">
                <div>
                  <h3>
                    <b>Sổ, giấy tờ</b>
                  </h3>
                  <h3 className="mt-4">
                    <b>* tối đa 5 (hình hoặc tập tin)</b>
                  </h3>
                  <div className="text-gray-500 text-sm">
                    <p>Chỉ liên quan đến Sổ, giấy tờ BĐS</p>
                    <p>Tập tin: pdf, word, excel, zip, jpg, png </p>
                    <p>Hình đầu tiên (rìa trái) sẽ là hình đại diện BĐS</p>
                  </div>
                </div>

                <div className="col-span-2">
                  {imageURLSSo.length <= 5 && (
                    <Button onClick={onButtonClickFileImageSo}>CHỌN SỔ: HÌNH ẢNH, TẬP TIN (KHÔNG VIDEO)</Button>
                  )}
                  <input
                    type="file"
                    // accept="image/*"
                    multiple
                    name="image"
                    id="file"
                    ref={inputFileSo}
                    style={{ display: 'none' }}
                    onChange={onFilechangeSo}
                  />{' '}
                  <div className="mt-1">Hiển thị ảnh ở đây</div>
                  <div className="grid grid-cols-3 lg:grid-cols-6 gap-4">
                    {checkInfo &&
                      imageURLsSoUpdate?.map((imageSrc, i) => (
                        <figure className="relative w-full border border-amber-500 border-dashed p-1" key={i}>
                          {typeImg(imageSrc) ? (
                            <img src={`${API_URL}/imgshop?name=${imageSrc}`} alt="not fount" width={'100%'} />
                          ) : (
                            <a href={`${API_URL}/imgshop?name=${imageSrc}`} download={imageSrc} width={'100%'}>
                              {'file_' + i + 1}
                            </a>
                          )}
                          <figcaption className="absolute bottom-4 left-2/4 flex px-1 -translate-x-2/4 justify-center rounded-xl border border-white bg-red-900 text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm">
                            <div>
                              <span onClick={() => removeImageSoUpdate(i)} className="cursor-pointer">
                                xóa
                              </span>
                            </div>
                          </figcaption>
                        </figure>
                      ))}
                    {imageURLSSo?.map((imageSrc, i) => (
                      <figure className="relative w-full border border-amber-500 border-dashed p-1" key={i}>
                        {imageSrc ? (
                          <img src={imageSrc} alt="not fount" width={'100%'} />
                        ) : (
                          <a href={URL.createObjectURL(imagesSo[i])} download={imagesSo[i].name}>
                            {imagesSo[i].name}
                          </a>
                        )}
                        <figcaption className="absolute bottom-4 left-2/4 flex px-1 -translate-x-2/4 justify-center rounded-xl border border-white bg-red-900 text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm">
                          <div>
                            <span onClick={() => removeImageSo(i)} className="cursor-pointer">
                              xóa
                            </span>
                          </div>
                        </figcaption>
                      </figure>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full">
              <label className="flex items-end gap-1 text-sm mb-1">
                <b> Tác giả</b>
              </label>
              <Select label="Chọn tác giả" value={arrBDS?.username}>
                {resultListUsers &&
                  resultListUsers.map((row, i) => (
                    <Option
                      key={i}
                      value={row?.username}
                      onClick={() => {
                        setArrBDS({ ...arrBDS, username: row?.username });
                      }}
                    >
                      {row?.username}
                      {row?.name ? `(${row?.name})` : ''}
                    </Option>
                  ))}
              </Select>
            </div>

            {arrHisBds.length > 0 && (
              <div className="border rounded-md bg-gray-100 p-2">
                {arrHisBds?.map((row, i) => (
                  <div key={i}>
                    <span>
                      - {row.update_date} đã chỉnh sửa bởi <b>{row.username}</b> <br />{' '}
                      <i>
                        Nội dung chỉnh sửa:
                        <b className="font-bold break-all whitespace-pre-wrap">
                          {row.noidung.replace(/"/g, '').replace(/,(?! )/g, ' - ')}
                        </b>
                      </i>
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="mt-2">
            {warningMessage && <p className="text-red-500 font-bold">{warningMessage}</p>}
            <Button
              color="orange"
              onClick={checkInfo ? subUpdateDefault : subAddDefault}
              disabled={isDisabled}
              loading={loading}
            >
              {checkInfo ? 'CẬP NHẬT' : 'LƯU THÊM MỚI'}
            </Button>
          </div>

          {message === 'Thành Công' && (
            <Alert
              icon={<BellAlertIcon className="h-5 w-5" />}
              className="rounded-none border-l-4 border-[#2ec946] bg-[#2ec946]/10 font-medium text-[#2ec946] flex items-center"
            >
              <b>THÊM TIN THÀNH CÔNG</b>
            </Alert>
          )}
          {checkInfo && (
            <div className="mt-2">
              <Link to="/addbds">
                <Button
                  className="flex items-center gap-3 bg-green-600"
                  size="sm"
                  onClick={() => {
                    reset();
                    setCheckInfo(false);
                  }}
                >
                  <HomeModernIcon strokeWidth={2} className="h-4 w-4" /> Thêm BĐS Mới
                </Button>
              </Link>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
